/* ==========================================================================
   Synapx Panel — comportements des controles (zero dependance).
   Auto-initialisation sur [data-sxp] ou via SxpPanel.init(root).
   - .sxp-knob      : potentiometre rotatif (glisser vertical / molette / clavier)
   - .sxp-tabs      : onglets (bouton [data-tab] -> pane #id)
   - .sxp-module    : bloc repliable (clic sur le titre)
   - [data-sxp-out] : reflete la valeur d'un input dans un <output>/element cible
   ========================================================================== */
(function (global) {
  'use strict';

  var NS = 'http://www.w3.org/2000/svg';
  function el(name, attrs) {
    var n = document.createElementNS(NS, name);
    for (var k in attrs) n.setAttribute(k, attrs[k]);
    return n;
  }
  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
  function round(v, step) { return Math.round(v / step) * step; }

  /* ---- requestAnimationFrame conditionne a la visibilite -----------------
     visibleRaf(el) rend { request(fn), cancel(id) } au contrat de rAF :
       - element visible (IntersectionObserver, seuil 0, UN observer partage)
         ET document non masque -> vrai requestAnimationFrame ;
       - sinon la fonction est mise en attente (id sentinelle negatif) et
         relancee d'elle-meme quand l'element ou l'onglet redevient visible ;
       - cancel(id) annule aussi bien un vrai id qu'une attente : un stop()
         demande reste un stop, meme si l'element revient a l'ecran.
     Sans IntersectionObserver : toujours visible (degradation gracieuse). */
  var visibleRaf = (function () {
    var IO = global.IntersectionObserver, io = null, entries = [], seq = 0, bound = false;
    function docHidden() { return !!(global.document && document.hidden); }
    function findEntry(el) {
      for (var i = 0; i < entries.length; i++) if (entries[i].el === el) return entries[i];
      return null;
    }
    function flush(e) {
      if (!e.visible || docHidden()) return;
      var list = e.pending; e.pending = [];
      for (var i = 0; i < list.length; i++) run(e, list[i]);
    }
    function run(e, p) {
      e.pending.push(p);
      p.real = global.requestAnimationFrame(function (ts) {
        var k = e.pending.indexOf(p); if (k >= 0) e.pending.splice(k, 1);
        p.fn(ts);
      });
    }
    function onIntersect(list) {
      for (var i = 0; i < list.length; i++) {
        var e = findEntry(list[i].target); if (!e) continue;
        e.visible = list[i].isIntersecting;
        if (e.visible) flush(e);
      }
    }
    function onVisibility() {
      if (docHidden()) return;
      for (var i = 0; i < entries.length; i++) flush(entries[i]);
    }
    return function (el) {
      var e = el && findEntry(el);
      if (!e) {
        // Avec un observer, l'element est repute invisible jusqu'a son premier
        // rapport (asynchrone) : aucune frame « a l'aveugle » hors ecran.
        e = { el: el, visible: !(IO && el), pending: [] };
        entries.push(e);
        if (IO && el) {
          if (!io) io = new IO(onIntersect, { threshold: 0 });
          io.observe(el);
        }
        if (!bound && global.document) { bound = true; document.addEventListener('visibilitychange', onVisibility); }
      }
      return {
        request: function (fn) {
          if (e.visible && !docHidden()) return global.requestAnimationFrame(fn);
          var p = { id: -(++seq), fn: fn, real: 0 };
          e.pending.push(p);
          return p.id;
        },
        cancel: function (id) {
          if (id > 0) { global.cancelAnimationFrame(id); return; }
          for (var i = 0; i < e.pending.length; i++) {
            if (e.pending[i].id === id) {
              if (e.pending[i].real) global.cancelAnimationFrame(e.pending[i].real);
              e.pending.splice(i, 1); return;
            }
          }
        }
      };
    };
  })();

  /* Degrade du capuchon : un seul <defs> partage par tous les knobs (un id
     SVG dupliqué par knob rendait le HTML invalide). */
  function ensureKnobDefs() {
    if (document.getElementById('sxpKnobGrad')) return;
    var svg = el('svg', { width: '0', height: '0', style: 'position:absolute', 'aria-hidden': 'true' });
    var defs = el('defs', {});
    var grad = el('radialGradient', { id: 'sxpKnobGrad', cx: '.5', cy: '.4', r: '.6' });
    grad.appendChild(el('stop', { offset: '0', 'stop-color': '#2b3742' }));
    grad.appendChild(el('stop', { offset: '1', 'stop-color': '#131a21' }));
    defs.appendChild(grad); svg.appendChild(defs);
    document.body.insertBefore(svg, document.body.firstChild);
  }

  /* ---- Potentiometre ---------------------------------------------------- */
  function buildKnob(node) {
    if (node.dataset.sxpReady) return;
    node.dataset.sxpReady = '1';

    var min = parseFloat(node.dataset.min || '0');
    var max = parseFloat(node.dataset.max || '100');
    var step = parseFloat(node.dataset.step || '1');
    var val = clamp(parseFloat(node.dataset.val || min), min, max);

    // Arc de 270 degres (de -135 a +135), classique sur un knob analogique.
    var A0 = -135, A1 = 135, R = 18, C = 24;
    ensureKnobDefs();
    var svg = el('svg', { viewBox: '0 0 48 48' });

    function arcPath(a0, a1) {
      var r0 = (a0 - 90) * Math.PI / 180, r1 = (a1 - 90) * Math.PI / 180;
      var x0 = C + R * Math.cos(r0), y0 = C + R * Math.sin(r0);
      var x1 = C + R * Math.cos(r1), y1 = C + R * Math.sin(r1);
      var large = (a1 - a0) > 180 ? 1 : 0;
      return 'M' + x0.toFixed(2) + ' ' + y0.toFixed(2) +
             ' A' + R + ' ' + R + ' 0 ' + large + ' 1 ' + x1.toFixed(2) + ' ' + y1.toFixed(2);
    }
    var track = el('path', { class: 'sxp-knob-track', d: arcPath(A0, A1), fill: 'none', 'stroke-width': '3', 'stroke-linecap': 'round' });
    var arc = el('path', { class: 'sxp-knob-arc', fill: 'none', 'stroke-width': '3', 'stroke-linecap': 'round' });
    var cap = el('circle', { class: 'sxp-knob-cap', cx: C, cy: C, r: '13' });
    var pointer = el('line', { class: 'sxp-knob-pointer', x1: C, y1: '14', x2: C, y2: '20' });
    svg.appendChild(track); svg.appendChild(arc); svg.appendChild(cap); svg.appendChild(pointer);
    node.appendChild(svg);

    node.setAttribute('role', 'slider');
    node.setAttribute('tabindex', '0');
    node.setAttribute('aria-valuemin', min);
    node.setAttribute('aria-valuemax', max);

    function render() {
      var t = (val - min) / (max - min);
      var ang = A0 + t * (A1 - A0);
      arc.setAttribute('d', arcPath(A0, ang));
      pointer.style.transform = 'rotate(' + ang + 'deg)';
      node.dataset.val = val;
      node.setAttribute('aria-valuenow', val);
    }
    function set(v, emit) {
      v = clamp(round(v, step), min, max);
      if (v === val) return;
      val = v; render();
      if (emit !== false) node.dispatchEvent(new CustomEvent('sxp:input', { bubbles: true, detail: { value: val } }));
    }
    render();

    var dragY = 0, dragV = 0;
    function onMove(e) {
      var y = (e.touches ? e.touches[0].clientY : e.clientY);
      var span = max - min;
      set(dragV + (dragY - y) / 140 * span);
    }
    function onUp() {
      document.removeEventListener('mousemove', onMove);
      document.removeEventListener('mouseup', onUp);
      document.removeEventListener('touchmove', onMove);
      document.removeEventListener('touchend', onUp);
    }
    function onDown(e) {
      e.preventDefault();
      dragY = (e.touches ? e.touches[0].clientY : e.clientY);
      dragV = val;
      document.addEventListener('mousemove', onMove);
      document.addEventListener('mouseup', onUp);
      document.addEventListener('touchmove', onMove, { passive: false });
      document.addEventListener('touchend', onUp);
    }
    node.addEventListener('mousedown', onDown);
    node.addEventListener('touchstart', onDown, { passive: false });
    node.addEventListener('wheel', function (e) { e.preventDefault(); set(val + (e.deltaY < 0 ? step : -step)); }, { passive: false });
    node.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowUp' || e.key === 'ArrowRight') { e.preventDefault(); set(val + step); }
      else if (e.key === 'ArrowDown' || e.key === 'ArrowLeft') { e.preventDefault(); set(val - step); }
    });
    // Pilotage externe (API, WebSocket) : met a jour le rendu sans re-emettre sxp:input.
    node._sxp = {
      set: function (v) { v = parseFloat(v); if (!isNaN(v)) set(v, false); },
      value: function () { return val; }
    };
  }

  /* ---- Commutateur rotatif crante (selecteur de mode) ------------------ */
  function buildSelector(el) {
    if (el.dataset.sxpReady) return;
    el.dataset.sxpReady = '1';
    var opts = Array.prototype.slice.call(el.querySelectorAll('[data-val]'));
    var n = opts.length; if (!n) return;
    var arc = parseFloat(el.dataset.arc || Math.min(300, (n - 1) * 80)); // amplitude totale (deg)
    var start = -arc / 2, step = n > 1 ? arc / (n - 1) : 0;
    var angles = opts.map(function (_, i) { return start + i * step; });  // 0 = haut, sens horaire

    var knob = document.createElement('div');
    knob.className = 'sxp-selector-knob'; knob.tabIndex = 0; knob.setAttribute('role', 'listbox');
    var ptr = document.createElement('span'); ptr.className = 'sxp-selector-ptr';
    knob.appendChild(ptr); el.appendChild(knob);

    var W = el.clientWidth || 120, cx = W / 2, cy = (el.clientHeight || W) / 2, Rlbl = W / 2 - 13;
    opts.forEach(function (o, i) {
      o.classList.add('sxp-selector-opt');
      var a = angles[i] * Math.PI / 180;
      o.style.left = (cx + Math.sin(a) * Rlbl) + 'px';
      o.style.top = (cy - Math.cos(a) * Rlbl) + 'px';
      o.addEventListener('click', function () { select(i, true); });
    });

    var idx = opts.findIndex(function (o) { return o.classList.contains('is-on'); });
    if (idx < 0) idx = 0;
    function render() {
      ptr.style.transform = 'rotate(' + angles[idx] + 'deg)';
      opts.forEach(function (o, i) { o.classList.toggle('is-on', i === idx); });
      knob.setAttribute('aria-activedescendant', opts[idx].textContent);
    }
    function select(i, emit) {
      i = (i + n) % n; var changed = i !== idx; idx = i; render();
      if (emit && changed) el.dispatchEvent(new CustomEvent('sxp:change', { bubbles: true, detail: { value: opts[idx].dataset.val, index: idx } }));
    }
    function evAngle(e) {
      var r = knob.getBoundingClientRect();
      return Math.atan2(e.clientX - (r.left + r.width / 2), -(e.clientY - (r.top + r.height / 2))) * 180 / Math.PI;
    }
    function nearest(a) {
      var best = 0, bd = 1e9;
      angles.forEach(function (ang, i) { var d = Math.abs(((a - ang + 540) % 360) - 180); if (d < bd) { bd = d; best = i; } });
      return best;
    }
    var dragging = false;
    knob.addEventListener('pointerdown', function (e) { dragging = true; knob.setPointerCapture(e.pointerId); select(nearest(evAngle(e)), true); e.preventDefault(); });
    knob.addEventListener('pointermove', function (e) { if (dragging) select(nearest(evAngle(e)), true); });
    function up() { dragging = false; }
    knob.addEventListener('pointerup', up); knob.addEventListener('pointercancel', up);
    knob.addEventListener('wheel', function (e) { e.preventDefault(); select(idx + (e.deltaY > 0 ? 1 : -1), true); }, { passive: false });
    knob.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight' || e.key === 'ArrowUp') { select(idx + 1, true); e.preventDefault(); }
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') { select(idx - 1, true); e.preventDefault(); }
    });
    render();
    el._sxp = {
      value: function () { return opts[idx].dataset.val; },
      select: function (v) { var i = opts.findIndex(function (o) { return o.dataset.val === v; }); if (i >= 0) select(i, true); }
    };
  }

  /* ---- Egaliseur / analyseur de spectre a LED -------------------------- */
  function buildEqualizer(el) {
    if (el.dataset.sxpReady) return;
    el.dataset.sxpReady = '1';
    var N = parseInt(el.dataset.bands || '32', 10);
    var bands = [], levels = new Array(N).fill(0), peaks = new Array(N).fill(0);
    for (var i = 0; i < N; i++) {
      var d = document.createElement('div'); d.className = 'sxp-eq-band';
      var lit = document.createElement('i'), pk = document.createElement('b');
      d.appendChild(lit); d.appendChild(pk); el.appendChild(d);
      bands.push({ lit: lit, pk: pk });
    }
    function measure() {
      var h = el.clientHeight - 16;              // hauteur utile (moins le padding)
      el.style.setProperty('--eqh', (h > 0 ? h : 104) + 'px');
    }
    var t = 0, raf = 0, running = false, onFrame = null;
    var vr = visibleRaf(el);
    var reduce = global.matchMedia && global.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function frame() {
      t += 0.045;
      // « musique » simulee : grave dominant + battement (kick) + medium/aigu + alea
      var beat = Math.pow(Math.max(0, Math.sin(t * 3.1)), 6);
      var beat2 = Math.pow(Math.max(0, Math.sin(t * 1.7 + 1)), 8);
      var sum = 0;
      for (var i = 0; i < N; i++) {
        var f = i / (N - 1);
        var bass = Math.exp(-f * 2.6);
        var mid = Math.abs(Math.sin(t * 2.3 + i * 0.55)) * (1 - f) * 0.5;
        var hi = Math.abs(Math.sin(t * 4.7 + i * 0.9)) * f * 0.35;
        var target = Math.min(1, bass * (0.1 + 0.9 * beat) + mid * (0.35 + 0.65 * beat2) + hi * 0.5 + Math.random() * 0.05);
        var cur = levels[i];
        cur += target > cur ? (target - cur) * 0.6 : (target - cur) * 0.12; // attaque vive, chute lente
        levels[i] = cur; sum += cur;
        peaks[i] = Math.max(peaks[i] - 0.01, cur);
        bands[i].lit.style.height = (cur * 100) + '%';
        bands[i].pk.style.bottom = (peaks[i] * 100) + '%';
      }
      // diffuse le spectre aux abonnes (faders, vumetre, voyants…)
      if (onFrame) onFrame({ levels: levels, level: sum / N, beat: beat });
      if (running) raf = vr.request(frame);
    }
    function statique() {
      for (var j = 0; j < N; j++) { bands[j].lit.style.height = (18 + 46 * Math.exp(-(j / (N - 1)) * 2.6)) + '%'; }
    }
    measure(); statique();
    var api = {
      start: function () { if (!running && !reduce) { running = true; measure(); frame(); } },
      stop: function () { running = false; if (raf) vr.cancel(raf); raf = 0; },
      onFrame: function (fn) { onFrame = fn; return api; },
      running: function () { return running; },
      // Pilotage EXTERNE : injecte un spectre (0..1 par bande) — pour brancher
      // une vraie FFT audio a la place de la simulation.
      feed: function (L) {
        var sum = 0;
        for (var i = 0; i < N; i++) {
          var cur = L[i] || 0; levels[i] = cur; sum += cur;
          peaks[i] = Math.max(peaks[i] - 0.012, cur);
          bands[i].lit.style.height = (cur * 100) + '%';
          bands[i].pk.style.bottom = (peaks[i] * 100) + '%';
        }
        var beat = ((L[0] || 0) + (L[1] || 0) + (L[2] || 0)) / 3;
        if (onFrame) onFrame({ levels: levels, level: sum / N, beat: beat });
      }
    };
    el._sxp = api;
    if (el.dataset.auto !== 'false' && !reduce) api.start();
  }

  /* ---- Onglets ---------------------------------------------------------- */
  function bindTabs(root) {
    root.querySelectorAll('.sxp-tabs').forEach(function (bar) {
      bar.addEventListener('click', function (e) {
        var b = e.target.closest('[data-tab]');
        if (!b) return;
        var scope = bar.closest('[data-sxp-tabs]') || document;
        bar.querySelectorAll('[data-tab]').forEach(function (x) { x.classList.toggle('is-on', x === b); });
        scope.querySelectorAll('.sxp-tabpane').forEach(function (p) {
          p.classList.toggle('is-on', p.id === b.dataset.tab);
        });
      });
    });
  }

  /* ---- Modules repliables ---------------------------------------------- */
  function bindModules(root) {
    root.querySelectorAll('.sxp-module>h3').forEach(function (h) {
      h.addEventListener('click', function () { h.parentNode.classList.toggle('is-collapsed'); });
    });
  }

  /* ---- Reflet valeur input -> sortie ----------------------------------- */
  function bindOutputs(root) {
    root.querySelectorAll('[data-sxp-out]').forEach(function (input) {
      var target = document.getElementById(input.dataset.sxpOut);
      if (!target) return;
      var suffix = input.dataset.sxpUnit || '';
      var upd = function () { target.textContent = input.value + suffix; };
      input.addEventListener('input', upd); upd();
    });
  }

  /* ---- Theme terminal : accordeon et volet a onglets (.sxp-t-acc) --------
     Trois gestes sur une meme ligne : onglet actif -> replie/deplie ;
     onglet inactif -> bascule sur cette face et deplie ; chevron -> replie
     sans changer de face. Un accordeon sans onglets se plie sur son en-tete. */
  function bindTerminalAcc(root) {
    root.querySelectorAll('.sxp-t-acc').forEach(function (sec) {
      if (sec.dataset.sxpReady) return;
      sec.dataset.sxpReady = '1';
      var head = sec.querySelector('.sxp-t-acc__head');
      if (!head) return;
      var onglets = Array.prototype.slice.call(head.querySelectorAll('.sxp-t-acc__onglet'));
      var panneaux = Array.prototype.slice.call(sec.querySelectorAll('.sxp-t-acc__panneau'));
      function emit() { sec.dispatchEvent(new CustomEvent('sxp:toggle', { bubbles: true, detail: { open: sec.classList.contains('is-open') } })); }
      if (!onglets.length) {
        head.addEventListener('click', function () { sec.classList.toggle('is-open'); emit(); });
        return;
      }
      if (onglets.length < 2) sec.classList.add('sxp-t-acc--une-face');
      head.setAttribute('role', 'tablist');
      function activer(i) {
        onglets.forEach(function (b, j) {
          var on = (j === i);
          b.classList.toggle('is-actif', on);
          b.setAttribute('aria-selected', on ? 'true' : 'false');
          if (panneaux[j]) panneaux[j].hidden = !on;
        });
        sec.dispatchEvent(new CustomEvent('sxp:tab', { bubbles: true, detail: { index: i } }));
      }
      onglets.forEach(function (b, i) {
        b.setAttribute('role', 'tab');
        if (panneaux[i]) { panneaux[i].setAttribute('role', 'tabpanel'); panneaux[i].hidden = !b.classList.contains('is-actif'); }
        b.addEventListener('click', function () {
          if (b.classList.contains('is-actif')) { sec.classList.toggle('is-open'); emit(); return; }
          sec.classList.add('is-open'); activer(i); emit();
        });
      });
      var replier = head.querySelector('.sxp-t-acc__replier');
      if (replier) replier.addEventListener('click', function () { sec.classList.toggle('is-open'); emit(); });
    });
  }

  function init(root) {
    root = root || document;
    root.querySelectorAll('.sxp-knob').forEach(buildKnob);
    root.querySelectorAll('.sxp-selector').forEach(buildSelector);
    root.querySelectorAll('.sxp-eq').forEach(buildEqualizer);
    bindTabs(root); bindModules(root); bindOutputs(root); bindTerminalAcc(root);
  }

  var SxpPanel = { init: init, buildKnob: buildKnob, buildSelector: buildSelector, buildEqualizer: buildEqualizer, visibleRaf: visibleRaf };
  global.SxpPanel = SxpPanel;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else { init(document); }
})(window);

/* ==========================================================================
   Synapx Panel — Phase 2 : appareils de mesure vintage FONCTIONNELS.
   Cadrans a aiguille dessines sur canvas (retina), pilotables par API.
   Base de dessin generalisee depuis la jauge cockpit de reference.

   API :
     var g = SxpPanel.gauge(canvas, opts);  g.set(valeur);
     var s = SxpPanel.scope(canvas, opts);   s.set({wave,freq,amp}); s.stop();
   Auto-init : <canvas class="sxp-inst" data-inst="manometer" ...>
   ========================================================================== */
(function (global) {
  'use strict';
  var TAU = Math.PI * 2, DEG = Math.PI / 180;
  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
  function num(v, d) { v = parseFloat(v); return isNaN(v) ? d : v; }
  // Respect de l'utilisateur qui limite les animations.
  var REDUCE = global.matchMedia && global.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var nowMs = function () { return (global.performance && performance.now) ? performance.now() : Date.now(); };
  // rAF conditionne a la visibilite (helper de panel.js, resolu a l'appel :
  // panel.js est charge avant) ; repli sur le rAF natif si le SDK est charge seul.
  function visibleRaf(el) {
    var f = global.SxpPanel && global.SxpPanel.visibleRaf;
    return f ? f(el) : {
      request: function (fn) { return global.requestAnimationFrame(fn); },
      cancel: function (id) { global.cancelAnimationFrame(id); }
    };
  }

  /* Prepare un canvas retina : dessine en unites logiques, net sur tout ecran. */
  function fit(canvas) {
    var dpr = Math.min(global.devicePixelRatio || 1, 2.5);
    var w = canvas.clientWidth || canvas.width || 160;
    var h = canvas.clientHeight || canvas.height || 160;
    canvas.width = Math.round(w * dpr);
    canvas.height = Math.round(h * dpr);
    var g = canvas.getContext('2d');
    g.setTransform(dpr, 0, 0, dpr, 0, 0);
    return { g: g, w: w, h: h };
  }

  /* ---- Jauge a aiguille generique ------------------------------------- */
  function gauge(canvas, opts) {
    opts = opts || {};
    var min = num(opts.min, 0), max = num(opts.max, 100);
    var a0 = num(opts.startDeg, -135), a1 = num(opts.endDeg, 135); // balayage
    var unit = opts.unit || '', label = opts.label || '';
    var zones = opts.zones || [];            // [{from,to,color}]
    var majors = num(opts.majorTicks, 5);
    var minors = num(opts.minorTicks, 4);    // sous-graduations par intervalle
    var accent = opts.accent || '#ff6600';
    var digital = opts.digital !== false;
    var decimals = num(opts.decimals, 0);

    var target = clamp(num(opts.value, min), min, max);
    var shown = target, raf = 0, vr = visibleRaf(canvas);
    // Oscillation « butée rouge » : l'aiguille vibre quand la valeur entre dans
    // une zone rouge (danger), avec apparition/disparition amortie.
    var DANGER_AMP = num(opts.dangerAmp, 0.045);   // amplitude max (rad, ~2.6°)
    var oscAmp = 0, oscPhase = 0, oscOffset = 0, inDanger = false;

    function isRed(c) {
      var m = /^#?([0-9a-f]{6})$/i.exec((c || '').trim()); if (!m) return false;
      var n = parseInt(m[1], 16), r = (n >> 16) & 255, g = (n >> 8) & 255, b = n & 255;
      return r > 170 && g < 110 && b < 130;        // rouge dominant (ex. #ff3355)
    }
    function danger(v) {
      for (var i = 0; i < zones.length; i++) {
        var z = zones[i];
        if (v >= Math.min(z.from, z.to) && v <= Math.max(z.from, z.to) && isRed(z.color)) return true;
      }
      return false;
    }

    function frac(v) { return (clamp(v, min, max) - min) / (max - min || 1); }
    function ang(v) { return (a0 + frac(v) * (a1 - a0)) * DEG - Math.PI / 2; }

    function draw() {
      var b = fit(canvas), g = b.g, W = b.w, H = b.h;
      var C = W / 2, CY = H / 2, R = Math.min(C, CY) - 4;
      g.clearRect(0, 0, W, H);
      // face + lunette
      g.beginPath(); g.arc(C, CY, R, 0, TAU);
      var grd = g.createRadialGradient(C, CY - R * 0.4, R * 0.1, C, CY, R);
      grd.addColorStop(0, '#161d25'); grd.addColorStop(1, '#0a0e12');
      g.fillStyle = grd; g.fill();
      g.lineWidth = 3; g.strokeStyle = '#5a6a7e'; g.stroke();
      g.beginPath(); g.arc(C, CY, R - 2, 0, TAU); g.lineWidth = 1; g.strokeStyle = '#12161d'; g.stroke();
      // arcs de zones colorees
      zones.forEach(function (z) {
        g.beginPath();
        g.arc(C, CY, R - 8, ang(z.from), ang(z.to));
        g.lineWidth = 4; g.strokeStyle = z.color; g.lineCap = 'butt'; g.stroke();
      });
      // graduations + valeurs
      var steps = majors * (minors + 1);
      for (var i = 0; i <= steps; i++) {
        var t = i / steps, maj = i % (minors + 1) === 0;
        var a = (a0 + t * (a1 - a0)) * DEG - Math.PI / 2;
        var r0 = R - (maj ? 14 : 9), r1 = R - 4;
        g.beginPath();
        g.moveTo(C + Math.cos(a) * r0, CY + Math.sin(a) * r0);
        g.lineTo(C + Math.cos(a) * r1, CY + Math.sin(a) * r1);
        g.strokeStyle = maj ? '#c9d4e4' : '#5a6a7e'; g.lineWidth = maj ? 1.6 : 1; g.stroke();
        if (maj) {
          var val = min + t * (max - min);
          g.fillStyle = '#8fa2bd'; g.font = (R * 0.13).toFixed(0) + 'px ui-monospace,monospace';
          g.textAlign = 'center'; g.textBaseline = 'middle';
          g.fillText(fmt(val, decimals), C + Math.cos(a) * (R - 24), CY + Math.sin(a) * (R - 24));
        }
      }
      // libelle
      if (label) {
        g.fillStyle = '#5a6b7c'; g.font = (R * 0.12).toFixed(0) + 'px ui-monospace,monospace';
        g.textAlign = 'center'; g.textBaseline = 'middle';
        g.fillText(label.toUpperCase(), C, CY - R * 0.42);
      }
      // afficheur numerique
      if (digital) {
        g.fillStyle = accent; g.font = 'bold ' + (R * 0.2).toFixed(0) + 'px ui-monospace,monospace';
        g.textAlign = 'center'; g.textBaseline = 'middle';
        g.fillText(fmt(shown, decimals) + (unit ? ' ' + unit : ''), C, CY + R * 0.5);
      }
      // aiguille (+ oscillation en butée rouge)
      var na = ang(shown) + oscOffset;
      g.strokeStyle = '#e8f0ff'; g.lineWidth = 2.4; g.lineCap = 'round';
      g.beginPath(); g.moveTo(C - Math.cos(na) * R * 0.18, CY - Math.sin(na) * R * 0.18);
      g.lineTo(C + Math.cos(na) * (R - 14), CY + Math.sin(na) * (R - 14)); g.stroke();
      g.strokeStyle = inDanger ? '#ff3355' : accent; g.lineWidth = 3;
      if (inDanger) { g.shadowColor = '#ff3355'; g.shadowBlur = 8; }
      g.beginPath();
      g.moveTo(C + Math.cos(na) * (R - 26), CY + Math.sin(na) * (R - 26));
      g.lineTo(C + Math.cos(na) * (R - 14), CY + Math.sin(na) * (R - 14)); g.stroke();
      g.shadowBlur = 0;
      // moyeu
      g.beginPath(); g.arc(C, CY, R * 0.06, 0, TAU); g.fillStyle = '#8fa2bd'; g.fill();
      g.beginPath(); g.arc(C, CY, R * 0.03, 0, TAU); g.fillStyle = '#0a0e12'; g.fill();
    }
    function fmt(v, d) { return d > 0 ? v.toFixed(d) : Math.round(v) + ''; }

    // Animation a inertie (lissage exponentiel). Continue tant que l'aiguille
    // bouge OU qu'elle vibre en zone rouge ; s'arrete une fois calme et hors danger.
    function tick() {
      shown += (target - shown) * 0.16;
      var settling = Math.abs(target - shown) >= (max - min) * 0.0006;
      if (!settling) shown = target;
      inDanger = danger(shown);
      oscAmp += ((inDanger ? DANGER_AMP : 0) - oscAmp) * 0.15;   // entree/sortie douce
      oscPhase += 0.35;                                           // ~3 Hz de tremblement
      oscOffset = oscAmp * (Math.sin(oscPhase) + 0.35 * Math.sin(oscPhase * 2.3));
      draw();
      if (settling || oscAmp > 0.0006) { raf = vr.request(tick); }
      else { oscOffset = 0; inDanger = false; draw(); raf = 0; }
    }
    function wake() { if (!raf) raf = vr.request(tick); }
    draw();
    if (danger(shown)) wake();       // demarre la vibration si on charge deja dans le rouge

    var api = {
      set: function (v) {
        target = clamp(num(v, target), min, max);
        if (!raf) raf = vr.request(tick);
        return api;
      },
      value: function () { return target; },
      config: function (o) {
        if ('min' in o) min = num(o.min, min); if ('max' in o) max = num(o.max, max);
        if ('unit' in o) unit = o.unit; if ('label' in o) label = o.label;
        if ('zones' in o) zones = o.zones; if ('accent' in o) accent = o.accent;
        if ('decimals' in o) decimals = num(o.decimals, decimals);
        if ('majorTicks' in o) majors = num(o.majorTicks, majors);
        if ('value' in o) { target = shown = clamp(num(o.value, target), min, max); }
        draw(); if (danger(shown)) wake(); return api;
      },
      redraw: draw
    };
    return api;
  }

  /* ---- Oscilloscope (trace phosphore animee) -------------------------- */
  function scope(canvas, opts) {
    opts = opts || {};
    var wave = opts.wave || 'sine';        // sine|square|triangle|saw|noise
    var freq = num(opts.freq, 2);          // cycles a l'ecran
    var amp = num(opts.amp, 0.7);          // 0..1 de la demi-hauteur
    var color = opts.color || '#33ff66';
    var sweep = clamp(num(opts.sweep, 0.5), 0, 1);     // vitesse de balayage
    var intensity = clamp(num(opts.intensity, 0.8), 0, 1); // brillance du faisceau
    var focus = clamp(num(opts.focus, 0.7), 0, 1);     // nettete (1 = net, 0 = flou)
    var disp = opts.disp || 'line';        // line|dots|xy|persist
    var power = opts.power !== false;      // tube allume
    var phase = 0, raf = 0, running = false, vr = visibleRaf(canvas);

    // Fit retina UNE fois (la persistance a besoin de conserver l'image).
    var b = fit(canvas), g = b.g, W = b.w, H = b.h;

    function shape(x) {                     // x en cycles (0..1 => 1 periode)
      var p = (x % 1 + 1) % 1;
      switch (wave) {
        case 'square': return p < 0.5 ? 1 : -1;
        case 'triangle': return p < 0.5 ? (4 * p - 1) : (3 - 4 * p);
        case 'saw': return 2 * p - 1;
        default: return Math.sin(p * TAU);
      }
    }
    function grid() {
      g.strokeStyle = 'rgba(51,255,102,.14)'; g.lineWidth = 1;
      for (var x = 0; x <= W; x += W / 10) { g.beginPath(); g.moveTo(x, 0); g.lineTo(x, H); g.stroke(); }
      for (var y = 0; y <= H; y += H / 8) { g.beginPath(); g.moveTo(0, y); g.lineTo(W, y); g.stroke(); }
      g.strokeStyle = 'rgba(51,255,102,.3)'; g.lineWidth = 1.2;
      g.beginPath(); g.moveTo(0, H / 2); g.lineTo(W, H / 2); g.stroke();
      g.beginPath(); g.moveTo(W / 2, 0); g.lineTo(W / 2, H); g.stroke();
    }
    function draw() {
      if (!power) {                         // tube eteint : ecran noir + reflet mort
        g.globalAlpha = 1; g.fillStyle = '#05080a'; g.fillRect(0, 0, W, H); return;
      }
      // effacement : franc, ou remanence (persistance) qui laisse une trainee
      if (disp === 'persist') { g.fillStyle = 'rgba(10,20,16,.16)'; g.fillRect(0, 0, W, H); }
      else { g.fillStyle = '#0a1410'; g.fillRect(0, 0, W, H); }
      grid();
      // faisceau : intensite -> opacite, nettete -> epaisseur + flou
      g.globalAlpha = 0.35 + intensity * 0.65;
      g.strokeStyle = color; g.fillStyle = color;
      g.lineWidth = 3.2 - focus * 2;
      g.shadowColor = color; g.shadowBlur = (2 + intensity * 6) + (1 - focus) * 9;
      g.lineJoin = 'round'; g.lineCap = 'round';
      var HA = H / 2 - 4;
      if (disp === 'xy') {                  // figure de Lissajous (voie X vs voie Y)
        var fx = Math.max(1, Math.round(freq)), fy = Math.max(1, Math.round(freq * 0.66) + 1);
        g.beginPath();
        for (var i = 0; i <= 360; i++) {
          var u = i / 360 * TAU;
          var px = W / 2 + Math.cos(fx * u + phase) * amp * (W / 2 - 6);
          var py = H / 2 - Math.sin(fy * u) * amp * HA;
          i === 0 ? g.moveTo(px, py) : g.lineTo(px, py);
        }
        g.stroke();
      } else if (disp === 'dots') {         // echantillons discrets (mode points)
        for (var dx = 0; dx <= W; dx += 5) {
          var vy = H / 2 - shape((dx / W) * freq + phase) * amp * HA;
          g.beginPath(); g.arc(dx, vy, 1.4, 0, TAU); g.fill();
        }
      } else {                              // trace continue (line / persist)
        g.beginPath();
        for (var qx = 0; qx <= W; qx++) {
          var yy = H / 2 - shape((qx / W) * freq + phase) * amp * HA;
          qx === 0 ? g.moveTo(qx, yy) : g.lineTo(qx, yy);
        }
        g.stroke();
      }
      g.shadowBlur = 0; g.globalAlpha = 1;
    }
    function loop() { phase += 0.006 + sweep * 0.045; draw(); if (running) raf = vr.request(loop); }
    function start() { if (!running && power) { running = true; loop(); } }
    function stop() { running = false; if (raf) vr.cancel(raf); raf = 0; }
    draw();
    var api = {
      set: function (o) {
        o = o || {};
        if ('wave' in o) wave = o.wave;
        if ('freq' in o) freq = num(o.freq, freq);
        if ('amp' in o) amp = clamp(num(o.amp, amp), 0, 1);
        if ('sweep' in o) sweep = clamp(num(o.sweep, sweep), 0, 1);
        if ('intensity' in o) intensity = clamp(num(o.intensity, intensity), 0, 1);
        if ('focus' in o) focus = clamp(num(o.focus, focus), 0, 1);
        if ('disp' in o) disp = o.disp;
        if ('color' in o) color = o.color;
        if ('power' in o) { power = !!o.power; power ? start() : (stop(), draw()); }
        if (!running) draw(); return api;
      },
      start: start, stop: stop
    };
    return api;
  }

  /* ---- Radar PPI (annees 1940) ---------------------------------------- */
  function radar(canvas, opts) {
    opts = opts || {};
    var speed = num(opts.speed, 0.028);      // vitesse de balayage (rad/frame)
    var gain = clamp(num(opts.gain, 0.7), 0, 1);
    var persist = clamp(num(opts.persist, 0.6), 0, 1);
    var range = clamp(num(opts.range, 0.7), 0, 1);
    var color = opts.color || '#33ff66';
    var b = fit(canvas), g = b.g, W = b.w, H = b.h;
    var C = W / 2, CY = H / 2, R = Math.min(C, CY) - 26; // marge pour l'echelle de gisement
    var angle = 0, raf = 0, running = false, vr = visibleRaf(canvas);
    // cibles : rayon, gisement, derive, taille, remanence propre
    var blips = [];
    for (var i = 0; i < 9; i++) blips.push({ r: 0.16 + Math.random() * 0.76, th: Math.random() * TAU, drift: (Math.random() - 0.5) * 0.006, size: 0.5 + Math.random(), life: 0 });
    g.fillStyle = '#050b07'; g.fillRect(0, 0, W, H);
    function P(r, a) { return [C + Math.cos(a) * r, CY + Math.sin(a) * r]; }
    function pad3(v) { return ('00' + v).slice(-3); }

    function frame() {
      g.globalAlpha = 1;
      // remanence (voile) sur la zone scope uniquement
      g.fillStyle = 'rgba(4,12,8,' + (0.05 + (1 - persist) * 0.30).toFixed(3) + ')';
      g.fillRect(0, 0, W, H);

      g.save(); g.beginPath(); g.arc(C, CY, R, 0, TAU); g.clip();
      // anneaux de portee + chiffres (NM)
      var rings = 4, maxNm = Math.round(10 + range * 40);
      g.strokeStyle = 'rgba(64,255,120,.15)'; g.lineWidth = 1;
      for (var k = 1; k <= rings; k++) { g.beginPath(); g.arc(C, CY, R * k / rings, 0, TAU); g.stroke(); }
      // rayons tous les 30° (0° en haut)
      for (var s = 0; s < 12; s++) { var p = P(R, s * Math.PI / 6 - Math.PI / 2); g.beginPath(); g.moveTo(C, CY); g.lineTo(p[0], p[1]); g.stroke(); }
      g.fillStyle = 'rgba(96,255,150,.4)'; g.font = '8px ui-monospace,monospace'; g.textAlign = 'left'; g.textBaseline = 'middle';
      for (var k2 = 1; k2 <= rings; k2++) g.fillText(Math.round(maxNm * k2 / rings) + '', C + 3, CY - R * k2 / rings);
      // clutter (herbe radar), plus dense pres du centre, selon le gain
      var speckle = Math.round(gain * 60);
      for (var q = 0; q < speckle; q++) {
        var rr0 = Math.pow(Math.random(), 1.7) * R, aa = Math.random() * TAU, pp = P(rr0, aa);
        g.fillStyle = 'rgba(64,255,120,' + (0.04 + gain * 0.09 * (1 - rr0 / R)).toFixed(3) + ')';
        g.fillRect(pp[0], pp[1], 1, 1);
      }
      // comete de balayage : afterglow angulaire (fondu quadratique)
      var trail = 1.7, steps = 26;
      for (var t2 = 0; t2 < steps; t2++) {
        var a1 = angle - (t2 / steps) * trail, a0 = angle - ((t2 + 1) / steps) * trail, al = (1 - t2 / steps);
        g.beginPath(); g.moveTo(C, CY); g.arc(C, CY, R, a0, a1); g.closePath();
        g.fillStyle = 'rgba(70,255,132,' + (al * al * 0.2).toFixed(3) + ')'; g.fill();
      }
      // bord d'attaque lumineux
      var pe = P(R, angle);
      g.strokeStyle = '#bfffd6'; g.lineWidth = 2; g.shadowColor = color; g.shadowBlur = 10;
      g.beginPath(); g.moveTo(C, CY); g.lineTo(pe[0], pe[1]); g.stroke(); g.shadowBlur = 0;
      // echos : arcs de retour radar
      blips.forEach(function (bl) {
        bl.th = (bl.th + bl.drift + TAU) % TAU;
        var d = Math.abs(((angle - bl.th + Math.PI * 3) % TAU) - Math.PI);
        if (d < 0.08) bl.life = 1;
        bl.life *= (0.9 + persist * 0.093);
        if (bl.life > 0.02) {
          var rr = bl.r * (0.45 + range * 0.55) * R, br = bl.life * gain, half = 0.04 + bl.size * 0.03;
          g.strokeStyle = 'rgba(190,255,210,' + br.toFixed(3) + ')';
          g.lineWidth = 2.2 + bl.size * 1.6 + br * 1.4; g.lineCap = 'round';
          g.shadowColor = color; g.shadowBlur = 12 * br;
          g.beginPath(); g.arc(C, CY, rr, bl.th - half, bl.th + half); g.stroke(); g.shadowBlur = 0;
        }
      });
      // centre + portee
      g.fillStyle = '#d8ffe4'; g.beginPath(); g.arc(C, CY, 2, 0, TAU); g.fill();
      g.fillStyle = 'rgba(120,255,160,.5)'; g.font = '8px ui-monospace,monospace'; g.textAlign = 'center';
      g.fillText(maxNm + ' NM', C, CY + R * 0.8);
      // vignette CRT
      var vg = g.createRadialGradient(C, CY, R * 0.55, C, CY, R);
      vg.addColorStop(0, 'rgba(0,0,0,0)'); vg.addColorStop(1, 'rgba(0,0,0,.55)');
      g.fillStyle = vg; g.fillRect(0, 0, W, H);
      g.restore();

      // lunette + couronne de gisement (hors clip)
      g.beginPath(); g.arc(C, CY, R, 0, TAU); g.strokeStyle = '#46584c'; g.lineWidth = 3; g.stroke();
      for (var t3 = 0; t3 < 72; t3++) {
        var ta = t3 * 5 * Math.PI / 180 - Math.PI / 2, maj = t3 % 6 === 0;
        var q0 = P(R + 2, ta), q1 = P(R + (maj ? 10 : 6), ta);
        g.strokeStyle = maj ? '#7a9a83' : '#3a4a40'; g.lineWidth = maj ? 1.4 : 1;
        g.beginPath(); g.moveTo(q0[0], q0[1]); g.lineTo(q1[0], q1[1]); g.stroke();
      }
      g.fillStyle = '#86ad92'; g.font = '8px ui-monospace,monospace'; g.textAlign = 'center'; g.textBaseline = 'middle';
      for (var l = 0; l < 12; l++) { var la = l * 30 * Math.PI / 180 - Math.PI / 2, ql = P(R + 18, la); g.fillText(pad3(l * 30), ql[0], ql[1]); }
      // repere de cap (lubber) en haut
      var lp = P(R + 2, -Math.PI / 2);
      g.fillStyle = '#ffd24a'; g.beginPath(); g.moveTo(lp[0] - 4, lp[1] - 9); g.lineTo(lp[0] + 4, lp[1] - 9); g.lineTo(lp[0], lp[1]); g.closePath(); g.fill();

      angle = (angle + speed) % TAU;
      if (running) raf = vr.request(frame);
    }
    frame();  // premier rendu statique
    var api = {
      set: function (o) {
        o = o || {};
        if ('speed' in o) speed = num(o.speed, speed);
        if ('gain' in o) gain = clamp(num(o.gain, gain), 0, 1);
        if ('persist' in o) persist = clamp(num(o.persist, persist), 0, 1);
        if ('range' in o) range = clamp(num(o.range, range), 0, 1);
        if (!running) frame(); return api;
      },
      start: function () { if (!running) { running = true; frame(); } },
      stop: function () { running = false; if (raf) vr.cancel(raf); raf = 0; }
    };
    return api;
  }

  /* ====================================================================
     Instruments de mesure vintage (Phase 3) — VU-metre, enregistreur,
     odometre a rouleaux, rotametre, thermometre, boussole, compteur Geiger.
     Chacun expose canvas._sxp = { set / feed / config, redraw }.
     ==================================================================== */

  /* ---- Compteur Geiger : cadran a aiguille + afficheur numerique ------- */
  function geiger(canvas, opts) {
    opts = opts || {};
    var maxV = num(opts.max, 30);                 // pleine echelle du cadran
    var target = clamp(num(opts.value, 0.15), 0, maxV * 4), shown = target;
    var b = fit(canvas), g = b.g, W = b.w, H = b.h;
    var C = W / 2, CY = H * 0.82, R = Math.min(W / 2, H * 0.72) - 10;
    var raf = 0, jitter = 0, tickPhase = 0, ledOn = 0, vr = visibleRaf(canvas);

    function frac(v) { return clamp(Math.sqrt(clamp(v, 0, maxV) / maxV), 0, 1); }
    function ang(f) { return Math.PI - f * Math.PI; }   // demi-cercle : gauche->droite

    function draw() {
      g.clearRect(0, 0, W, H);
      // boitier bakelite
      g.fillStyle = '#12171f'; g.fillRect(0, 0, W, H);
      g.strokeStyle = '#2a3542'; g.lineWidth = 2; g.strokeRect(3, 3, W - 6, H - 6);
      // fenetre du cadran
      g.save();
      g.beginPath(); g.arc(C, CY, R + 6, Math.PI, 0); g.lineTo(C + R + 6, CY + 6);
      g.lineTo(C - R - 6, CY + 6); g.closePath();
      var grd = g.createRadialGradient(C, CY - R * 0.3, R * 0.1, C, CY, R);
      grd.addColorStop(0, '#1b2028'); grd.addColorStop(1, '#0a0e12'); g.fillStyle = grd; g.fill();
      g.restore();
      // arcs de zones : vert / ambre / rouge
      function arc(f0, f1, col) {
        g.beginPath(); g.arc(C, CY, R, ang(f0), ang(f1), true);
        g.strokeStyle = col; g.lineWidth = 4; g.lineCap = 'butt'; g.stroke();
      }
      arc(0, 0.55, '#33ff66'); arc(0.55, 0.8, '#ffb000'); arc(0.8, 1, '#ff3355');
      // graduations
      for (var i = 0; i <= 10; i++) {
        var f = i / 10, a = ang(f), maj = i % 2 === 0;
        var r0 = R - (maj ? 12 : 7);
        g.beginPath();
        g.moveTo(C + Math.cos(a) * r0, CY - Math.sin(a) * r0);
        g.lineTo(C + Math.cos(a) * (R - 2), CY - Math.sin(a) * (R - 2));
        g.strokeStyle = maj ? '#c9d4e4' : '#5a6a7e'; g.lineWidth = maj ? 1.6 : 1; g.stroke();
      }
      // titre + unite
      g.fillStyle = '#7c8ba0'; g.font = '9px ui-monospace,monospace';
      g.textAlign = 'center'; g.textBaseline = 'middle';
      g.fillText('RADIOACTIVITE', C, CY - R * 0.55);
      // aiguille (+ sursaut aleatoire = crepitement)
      var na = ang(frac(shown)) + jitter;
      g.strokeStyle = '#ff5544'; g.lineWidth = 2; g.lineCap = 'round';
      g.shadowColor = '#ff3355'; g.shadowBlur = 4;
      g.beginPath(); g.moveTo(C, CY);
      g.lineTo(C + Math.cos(na) * (R - 6), CY - Math.sin(na) * (R - 6)); g.stroke();
      g.shadowBlur = 0;
      g.beginPath(); g.arc(C, CY, R * 0.06, 0, TAU); g.fillStyle = '#c9a24a'; g.fill();
      // afficheur numerique + voyant de comptage
      var boxY = H - 22;
      g.fillStyle = '#05080a'; g.fillRect(C - 46, boxY - 10, 92, 20);
      g.strokeStyle = '#2a3542'; g.lineWidth = 1; g.strokeRect(C - 46, boxY - 10, 92, 20);
      g.fillStyle = '#b6ff3b'; g.font = 'bold 13px ui-monospace,monospace';
      g.fillText(shown.toFixed(2) + ' uSv/h', C, boxY);
      g.beginPath(); g.arc(C - 58, boxY, 4, 0, TAU);
      g.fillStyle = 'rgba(182,255,59,' + (0.2 + ledOn * 0.8).toFixed(2) + ')'; g.fill();
    }

    function tick() {
      shown += (target - shown) * 0.18;
      if (Math.abs(target - shown) < maxV * 0.0006) shown = target;
      // crepitement : proba de « clic » croissante avec la dose (+ un fond leger)
      var rate = 0.04 + Math.min(1, shown / maxV) * 0.7;
      if (Math.random() < rate) { ledOn = 1; jitter = (Math.random() - 0.5) * 0.06 * (0.3 + shown / maxV); }
      ledOn *= 0.7; jitter *= 0.6;
      draw();
      raf = REDUCE ? 0 : vr.request(tick);
    }
    draw();
    if (!REDUCE) raf = vr.request(tick);

    var api = {
      set: function (v) { target = clamp(num(v, target), 0, maxV * 4); if (!raf && !REDUCE) raf = vr.request(tick); else if (REDUCE) draw(); return api; },
      value: function () { return target; },
      config: function (o) { if (o && 'max' in o) maxV = num(o.max, maxV); draw(); return api; },
      redraw: draw
    };
    return api;
  }

  /* ---- Boussole : rose des vents laiton + aiguille N/S ----------------- */
  function compass(canvas, opts) {
    opts = opts || {};
    var target = num(opts.value, 0), shown = target;
    var spin = false, spinVel = 0;
    var b = fit(canvas), g = b.g, W = b.w, H = b.h;
    var C = W / 2, CY = H / 2, R = Math.min(C, CY) - 4;
    var raf = 0, vr = visibleRaf(canvas);

    // Une branche de la rose : losange bicolore (moitie claire / moitie sombre),
    // a=0 pointe vers le haut (Nord de la carte).
    function rosePoint(a, len, hw, light, dark) {
      var dx = Math.sin(a), dy = -Math.cos(a), px = -dy, py = dx;
      var tx = dx * len, ty = dy * len;
      var bx = dx * len * 0.16, by = dy * len * 0.16;
      g.beginPath(); g.moveTo(0, 0); g.lineTo(bx + px * hw, by + py * hw); g.lineTo(tx, ty); g.closePath();
      g.fillStyle = light; g.fill();
      g.beginPath(); g.moveTo(0, 0); g.lineTo(bx - px * hw, by - py * hw); g.lineTo(tx, ty); g.closePath();
      g.fillStyle = dark; g.fill();
      g.strokeStyle = 'rgba(60,45,20,.45)'; g.lineWidth = 0.6;
      g.beginPath(); g.moveTo(0, 0); g.lineTo(tx, ty); g.stroke();
    }
    // Fleur de lys stylisee, posee au Nord de la carte.
    function fleur(cr) {
      var u = cr * 0.11; g.save(); g.translate(0, -cr * 0.9); g.fillStyle = '#b23a24';
      g.beginPath(); g.moveTo(0, u); g.bezierCurveTo(0.55 * u, 0.2 * u, 0.3 * u, -0.8 * u, 0, -1.15 * u);
      g.bezierCurveTo(-0.3 * u, -0.8 * u, -0.55 * u, 0.2 * u, 0, u); g.fill();
      var s;
      for (s = -1; s <= 1; s += 2) {
        g.beginPath(); g.moveTo(0, 0.55 * u);
        g.bezierCurveTo(s * u, 0, s * 1.05 * u, -0.55 * u, s * 0.45 * u, -0.5 * u);
        g.bezierCurveTo(s * 0.2 * u, -0.2 * u, s * 0.2 * u, 0.3 * u, 0, 0.55 * u); g.fill();
      }
      g.fillRect(-0.5 * u, 0.5 * u, u, 0.22 * u); g.restore();
    }

    function draw() {
      g.clearRect(0, 0, W, H);
      // lunette laiton + cuvette sombre
      var lg = g.createRadialGradient(C, CY - R * 0.4, R * 0.2, C, CY, R + 4);
      lg.addColorStop(0, '#e8cf8a'); lg.addColorStop(0.5, '#c9a24a'); lg.addColorStop(1, '#6f5320');
      g.beginPath(); g.arc(C, CY, R, 0, TAU); g.strokeStyle = lg; g.lineWidth = 7; g.stroke();
      g.beginPath(); g.arc(C, CY, R - 3, 0, TAU); g.fillStyle = '#0c1017'; g.fill();

      // ── Carte de compas tournante (rose des vents) ──
      var cr = R - 6;
      g.save(); g.translate(C, CY); g.rotate(-shown * DEG);
      // disque parchemin vieilli
      var pg = g.createRadialGradient(0, -cr * 0.25, cr * 0.1, 0, 0, cr);
      pg.addColorStop(0, '#f3ead2'); pg.addColorStop(1, '#cbb98c');
      g.beginPath(); g.arc(0, 0, cr, 0, TAU); g.fillStyle = pg; g.fill();
      g.beginPath(); g.arc(0, 0, cr * 0.9, 0, TAU); g.strokeStyle = 'rgba(74,59,34,.5)'; g.lineWidth = 1; g.stroke();
      // couronne des degres (tous les 2°, majeurs a 30°)
      var i, a, sx, sy;
      for (i = 0; i < 180; i++) {
        a = i * 2 * DEG; var maj = i % 15 === 0, med = i % 5 === 0, r0 = cr - (maj ? 12 : med ? 8 : 5);
        sx = Math.sin(a); sy = -Math.cos(a);
        g.strokeStyle = '#4a3b22'; g.lineWidth = maj ? 1.4 : 0.7;
        g.beginPath(); g.moveTo(sx * r0, sy * r0); g.lineTo(sx * (cr - 2), sy * (cr - 2)); g.stroke();
      }
      // nombres tous les 30°
      g.fillStyle = '#4a3b22'; g.font = 'bold ' + Math.round(cr * 0.085) + 'px ui-monospace,monospace';
      g.textAlign = 'center'; g.textBaseline = 'middle';
      for (var d = 0; d < 360; d += 30) {
        a = d * DEG; var rr = cr - 20; g.save(); g.translate(Math.sin(a) * rr, -Math.cos(a) * rr); g.rotate(a);
        g.fillText(d === 0 ? '360' : ('' + d), 0, 0); g.restore();
      }
      // branches : 8 demi-vents fins, 4 ordinaux, 4 cardinaux (Nord rouge)
      var lgt = '#f7f0dd', drk = '#3a2f1c';
      for (i = 0; i < 16; i++) if (i % 2) rosePoint(i * 22.5 * DEG, cr * 0.40, cr * 0.045, '#dcc78f', '#8a713c');
      for (i = 0; i < 4; i++) rosePoint((45 + i * 90) * DEG, cr * 0.60, cr * 0.085, lgt, drk);
      for (i = 0; i < 4; i++) rosePoint(i * 90 * DEG, cr * 0.82, cr * 0.11, i === 0 ? '#ffd9c2' : lgt, i === 0 ? '#b23a24' : drk);
      fleur(cr);
      // lettres cardinales (serif, Nord en rouge)
      var L = ['N', 'E', 'S', 'O']; g.font = 'bold ' + Math.round(cr * 0.12) + 'px Georgia,serif';
      for (var k = 0; k < 4; k++) {
        a = k * 90 * DEG; var lr = cr - 33; g.save(); g.translate(Math.sin(a) * lr, -Math.cos(a) * lr); g.rotate(a);
        g.fillStyle = k === 0 ? '#b23a24' : '#4a3b22'; g.fillText(L[k], 0, 0); g.restore();
      }
      // moyeu laiton
      g.beginPath(); g.arc(0, 0, cr * 0.06, 0, TAU); g.fillStyle = '#c9a24a'; g.fill();
      g.beginPath(); g.arc(0, 0, cr * 0.028, 0, TAU); g.fillStyle = '#3a2f1c'; g.fill();
      g.restore();

      // ── Repere de foi (lubber line) fixe en haut ──
      g.strokeStyle = '#ff3b2f'; g.lineWidth = 2; g.lineCap = 'round';
      g.beginPath(); g.moveTo(C, CY - R + 2); g.lineTo(C, CY - R + 13); g.stroke();
      g.beginPath(); g.arc(C, CY - R + 3, 2.4, 0, TAU); g.fillStyle = '#ff3b2f'; g.fill();
      // reflet verre
      g.save(); g.beginPath(); g.arc(C, CY, R - 3, 0, TAU); g.clip();
      var gl = g.createLinearGradient(0, CY - R, 0, CY + R * 0.2);
      gl.addColorStop(0, 'rgba(255,255,255,.16)'); gl.addColorStop(1, 'rgba(255,255,255,0)');
      g.fillStyle = gl; g.fillRect(0, CY - R, W, R * 1.2); g.restore();
    }

    function norm(a) { return ((a % 360) + 360) % 360; }
    function tick() {
      if (spin) {
        spinVel += (Math.random() - 0.5) * 4;             // carte affolee (anomalie)
        spinVel = clamp(spinVel, -18, 18);
        shown = norm(shown + spinVel);
        draw(); raf = vr.request(tick); return;
      }
      var d = ((target - shown + 540) % 360) - 180;       // plus court chemin
      shown = norm(shown + d * 0.16);
      draw();
      if (Math.abs(d) > 0.3) raf = vr.request(tick);
      else { shown = target; draw(); raf = 0; }
    }
    draw();

    var api = {
      set: function (v) {
        if (v === 'spin' || v === true) { spin = true; if (!raf) raf = vr.request(tick); return api; }
        if (v === 'normal' || v === false) { spin = false; spinVel = 0; }
        else { spin = false; target = num(v, target); }
        if (!raf) raf = vr.request(tick);
        return api;
      },
      value: function () { return target; },
      config: function (o) { draw(); return api; },
      redraw: draw
    };
    return api;
  }

  /* ---- Thermometre a colonne de mercure -------------------------------- */
  function thermometer(canvas, opts) {
    opts = opts || {};
    var min = num(opts.min, -40), max = num(opts.max, 50), unit = opts.unit || '°C';
    var target = clamp(num(opts.value, 20), min, max), shown = target;
    var b = fit(canvas), g = b.g, W = b.w, H = b.h;
    var cx = W * 0.42, top = 16, bulbR = W * 0.16, bot = H - bulbR - 10;
    var tubeW = W * 0.16, raf = 0, vr = visibleRaf(canvas);

    function frac(v) { return (clamp(v, min, max) - min) / (max - min || 1); }
    function draw() {
      g.clearRect(0, 0, W, H);
      g.fillStyle = '#0c1017'; g.fillRect(0, 0, W, H);
      // tube en verre
      g.beginPath();
      g.moveTo(cx - tubeW / 2, top); g.lineTo(cx - tubeW / 2, bot);
      g.arc(cx, bot, bulbR, Math.PI, 0, true);
      g.lineTo(cx + tubeW / 2, top); g.arc(cx, top, tubeW / 2, 0, Math.PI, true);
      g.closePath();
      g.fillStyle = '#161c24'; g.fill();
      g.strokeStyle = '#3a4653'; g.lineWidth = 1.5; g.stroke();
      // colonne de mercure
      var yTop = bot - frac(shown) * (bot - top - 4);
      g.fillStyle = '#ff4d4d';
      g.beginPath(); g.arc(cx, bot, bulbR - 3, 0, TAU); g.fill();
      g.fillRect(cx - tubeW / 2 + 3, yTop, tubeW - 6, bot - yTop);
      // reflets
      g.fillStyle = 'rgba(255,255,255,.18)';
      g.fillRect(cx - tubeW / 2 + 4, top + 2, 2, bot - top);
      // graduations + valeurs a droite
      g.strokeStyle = '#5a6a7e'; g.fillStyle = '#8fa2bd';
      g.font = '9px ui-monospace,monospace'; g.textAlign = 'left'; g.textBaseline = 'middle';
      var span = max - min, stepN = 9;
      for (var i = 0; i <= stepN; i++) {
        var v = min + span * i / stepN, y = bot - frac(v) * (bot - top - 4);
        var maj = i % 3 === 0;
        g.beginPath(); g.moveTo(cx + tubeW / 2 + 2, y); g.lineTo(cx + tubeW / 2 + (maj ? 10 : 6), y);
        g.lineWidth = 1; g.stroke();
        if (maj) g.fillText(Math.round(v) + '', cx + tubeW / 2 + 13, y);
      }
      // afficheur
      g.fillStyle = '#b6ff3b'; g.font = 'bold 13px ui-monospace,monospace';
      g.textAlign = 'center'; g.textBaseline = 'alphabetic';
      g.fillText(shown.toFixed(1) + ' ' + unit, W / 2, H - 3);
    }
    function tick() {
      shown += (target - shown) * 0.14;
      var moving = Math.abs(target - shown) > (max - min) * 0.001;
      if (!moving) shown = target;
      draw();
      if (moving && !REDUCE) raf = vr.request(tick); else raf = 0;
    }
    draw();
    var api = {
      set: function (v) { target = clamp(num(v, target), min, max); if (!raf && !REDUCE) raf = vr.request(tick); else if (REDUCE) { shown = target; draw(); } return api; },
      value: function () { return target; },
      config: function (o) { if (o) { if ('min' in o) min = num(o.min, min); if ('max' in o) max = num(o.max, max); if ('unit' in o) unit = o.unit; } draw(); return api; },
      redraw: draw
    };
    return api;
  }

  /* ---- VU-metre a aiguille (balistique : attaque vive, chute lente) ---- */
  function vumeter(canvas, opts) {
    opts = opts || {};
    var target = clamp(num(opts.value, 0), 0, 1), shown = 0;
    var b = fit(canvas), g = b.g, W = b.w, H = b.h;
    var C = W / 2, CY = H * 0.96, R = Math.min(W / 2, H * 0.92) - 6;
    var A0 = -50 * DEG, A1 = 50 * DEG, raf = 0, vr = visibleRaf(canvas);

    function draw() {
      g.clearRect(0, 0, W, H);
      // fond ivoire retro-eclaire
      var grd = g.createLinearGradient(0, 0, 0, H);
      grd.addColorStop(0, '#f3e4bf'); grd.addColorStop(1, '#d8c79c');
      g.fillStyle = grd; g.fillRect(0, 0, W, H);
      g.strokeStyle = '#3a2e18'; g.lineWidth = 2; g.strokeRect(2, 2, W - 4, H - 4);
      // arc + graduations
      function pa(f) { return -Math.PI / 2 + A0 + f * (A1 - A0); }
      g.strokeStyle = '#5a4a28'; g.lineWidth = 1.4;
      g.beginPath(); g.arc(C, CY, R, pa(0) + Math.PI / 2 - Math.PI / 2, pa(1)); // trace de reference
      g.beginPath();
      for (var i = 0; i <= 10; i++) {
        var f = i / 10, a = pa(f), red = f > 0.72;
        var r0 = R - (i % 2 === 0 ? 12 : 7);
        g.beginPath();
        g.moveTo(C + Math.cos(a) * r0, CY + Math.sin(a) * r0);
        g.lineTo(C + Math.cos(a) * R, CY + Math.sin(a) * R);
        g.strokeStyle = red ? '#c0392b' : '#3a2e18'; g.lineWidth = i % 2 === 0 ? 1.6 : 1; g.stroke();
      }
      // zone rouge (surcharge)
      g.beginPath(); g.arc(C, CY, R - 2, pa(0.72), pa(1)); g.strokeStyle = '#c0392b'; g.lineWidth = 3; g.stroke();
      // echelle VU
      g.fillStyle = '#3a2e18'; g.font = '9px ui-monospace,monospace'; g.textAlign = 'center'; g.textBaseline = 'middle';
      g.fillText('VU', C, CY - R * 0.5);
      g.fillText('-20', C + Math.cos(pa(0.08)) * (R - 22), CY + Math.sin(pa(0.08)) * (R - 22));
      g.fillText('0', C + Math.cos(pa(0.72)) * (R - 22), CY + Math.sin(pa(0.72)) * (R - 22));
      g.fillText('+3', C + Math.cos(pa(0.95)) * (R - 22), CY + Math.sin(pa(0.95)) * (R - 22));
      // aiguille
      var na = pa(shown);
      g.strokeStyle = '#1a1206'; g.lineWidth = 2; g.lineCap = 'round';
      g.beginPath(); g.moveTo(C, CY); g.lineTo(C + Math.cos(na) * (R - 4), CY + Math.sin(na) * (R - 4)); g.stroke();
      g.beginPath(); g.arc(C, CY, 4, 0, TAU); g.fillStyle = '#1a1206'; g.fill();
    }
    function tick() {
      // balistique : monte vite, redescend lentement
      shown += target > shown ? (target - shown) * 0.5 : (target - shown) * 0.08;
      var moving = Math.abs(target - shown) > 0.002;
      if (!moving) shown = target;
      draw();
      if (moving && !REDUCE) raf = vr.request(tick); else raf = 0;
    }
    draw();
    var api = {
      set: function (v) { target = clamp(num(v, target), 0, 1); if (!raf && !REDUCE) raf = vr.request(tick); else if (REDUCE) { shown = target; draw(); } return api; },
      feed: function (v) { return api.set(v); },
      value: function () { return target; },
      config: function (o) { draw(); return api; },
      redraw: draw
    };
    return api;
  }

  /* ---- Enregistreur a bande (strip-chart qui defile) ------------------- */
  function recorder(canvas, opts) {
    opts = opts || {};
    var b = fit(canvas), g = b.g, W = b.w, H = b.h;
    var padL = 8, padR = 8, padT = 10, padB = 10;
    var x0 = padL, x1 = W - padR, y0 = padT, y1 = H - padB;
    var mid = (y0 + y1) / 2, amp = (y1 - y0) / 2;
    var N = Math.max(60, Math.round(x1 - x0));
    var buf = [], level = null, cur = 0.5, raf = 0, t = 0, paperX = 0, vr = visibleRaf(canvas);
    // etat du seisme : energie restante, duree, magnitude ; act = niveau
    // d'activite (0 = volcan endormi -> trace plate ; monte lors des reveils)
    var qt = 0, qdur = 0, qmag = 0, quaking = false, act = 0.15;
    for (var i = 0; i < N; i++) buf.push(0.5);

    // Modele sismographe d'un VOLCAN EN ACTIVITE : tremor harmonique permanent
    // (toujours visible) ponctue de crises telluriques (onde P breve puis onde S
    // ample qui decroit). Autonome, non couple a la map. Renvoie 0..1.
    function seismo(dt) {
      t += dt;
      // L'activite retombe lentement vers 0 : entre deux episodes, le tremor
      // s'eteint et la trace redevient TRES plate (volcan endormi).
      act += (0 - act) * 0.008; if (act < 0.006) act = 0;
      var tremor = (0.06 * Math.sin(t * 6.2) + 0.032 * Math.sin(t * 12.1 + 1.3)
                 + 0.018 * Math.sin(t * 22.5) + (Math.random() - 0.5) * 0.03) * act;
      var v = 0.5 + tremor;
      if (qt > 0) {
        qt -= dt;
        var age = qdur - qt;                              // temps depuis le debut
        var env = Math.exp(-age * 1.05) * qmag;           // enveloppe qui retombe
        var shake = 0.62 * Math.sin(age * 41) + 0.4 * Math.sin(age * 26.5) + (Math.random() - 0.5) * 0.6;
        v += env * shake;
        if (qt <= 0) { qt = 0; quaking = false; }
      } else if (Math.random() < 0.0022) {                // secousse franche (rare)
        qmag = 0.22 + Math.random() * 0.2;
        qdur = 1.4 + Math.random() * 2;
        qt = qdur; quaking = true;
        act = Math.min(1, act + 0.7);                     // la crise reveille le volcan
      } else if (Math.random() < 0.0016) {                // simple reveil de tremor (sans seisme)
        act = Math.min(1, act + 0.3 + Math.random() * 0.4);
      }
      return clamp(v, 0.03, 0.97);
    }

    var INK = '#8f2417';                                   // encre unique (rouge sepia)
    function draw() {
      // ── Fond : vieux papier enregistreur sepia ──
      var pg = g.createLinearGradient(0, 0, 0, H);
      pg.addColorStop(0, '#efe6cd'); pg.addColorStop(0.5, '#e8dcbd'); pg.addColorStop(1, '#dccaa2');
      g.fillStyle = pg; g.fillRect(0, 0, W, H);

      g.save();
      g.beginPath(); g.rect(x0, y0, x1 - x0, y1 - y0); g.clip();
      // lignes d'amplitude horizontales (encre passee)
      g.lineWidth = 1;
      for (var r = 0; r <= 8; r++) {
        var gy = y0 + (y1 - y0) * r / 8;
        g.strokeStyle = (r % 4 === 0) ? 'rgba(110,60,25,.34)' : 'rgba(120,80,45,.15)';
        g.beginPath(); g.moveTo(x0, gy); g.lineTo(x1, gy); g.stroke();
      }
      // ligne de repos (zero)
      g.strokeStyle = 'rgba(150,45,25,.30)'; g.lineWidth = 1;
      g.beginPath(); g.moveTo(x0, mid); g.lineTo(x1, mid); g.stroke();
      // lignes de temps a espacement LOGARITHMIQUE, defilant vers la gauche,
      // a moitie effacees (faible opacite)
      var decW = (x1 - x0) / 3.2, LN10 = Math.log(10);
      for (var bx = x1 - (paperX % decW); bx > x0 - decW; bx -= decW) {
        for (var s = 1; s <= 9; s++) {
          var lx = bx - decW * (1 - Math.log(s) / LN10);    // serrees vers la droite de la decade
          if (lx < x0 || lx > x1) continue;
          var heavy = (s === 1);
          g.strokeStyle = heavy ? 'rgba(110,60,25,.32)' : 'rgba(120,85,45,.13)';
          g.lineWidth = heavy ? 1.1 : 0.6;
          g.beginPath(); g.moveTo(lx, y0); g.lineTo(lx, y1); g.stroke();
        }
      }
      // ── Trace a l'encre (couleur UNIQUE, constante) ──
      g.strokeStyle = INK; g.lineWidth = 1.6; g.lineCap = 'round'; g.lineJoin = 'round';
      g.beginPath();
      for (var k = 0; k < N; k++) {
        var tx = x0 + (k / (N - 1)) * (x1 - x0);
        var ty = y1 - buf[k] * (y1 - y0);
        k === 0 ? g.moveTo(tx, ty) : g.lineTo(tx, ty);
      }
      g.stroke();
      g.restore();

      // usure : vignette sepia sur les bords (papier a moitie efface)
      var vg = g.createRadialGradient(W / 2, mid, Math.min(W, H) * 0.25, W / 2, mid, Math.max(W, H) * 0.62);
      vg.addColorStop(0, 'rgba(0,0,0,0)'); vg.addColorStop(1, 'rgba(80,50,15,.32)');
      g.fillStyle = vg; g.fillRect(0, 0, W, H);
      // perforations d'entrainement de la bande
      g.fillStyle = 'rgba(95,62,25,.5)';
      for (var px = x0; px < x1; px += 14) { g.beginPath(); g.arc(px, y0 - 4, 1.3, 0, TAU); g.fill(); g.beginPath(); g.arc(px, y1 + 4, 1.3, 0, TAU); g.fill(); }

      // ── Bras du stylet + plume encreuse ──
      var py = y1 - cur * (y1 - y0), pivx = x0 + 5, pivy = y0 - 5;
      g.strokeStyle = '#9aa6b0'; g.lineWidth = 2.2; g.lineCap = 'round';
      g.beginPath(); g.moveTo(pivx, pivy); g.lineTo(x1, py); g.stroke();
      g.strokeStyle = 'rgba(255,255,255,.45)'; g.lineWidth = 0.7;
      g.beginPath(); g.moveTo(pivx, pivy - 1); g.lineTo(x1, py - 1); g.stroke();
      g.fillStyle = '#7c8894'; g.beginPath(); g.arc(pivx, pivy, 3, 0, TAU); g.fill();
      g.fillStyle = INK; g.beginPath(); g.arc(x1, py, 2.8, 0, TAU); g.fill();
    }

    function tick() {
      var dt = 0.03;
      var target = (level == null) ? seismo(dt) : clamp(level, 0, 1);
      cur += (target - cur) * (quaking ? 0.8 : 0.6);      // suit de pres -> courbe dentelee visible
      buf.push(clamp(cur, 0, 1)); if (buf.length > N) buf.shift();
      paperX += 0.5;                                        // defilement du papier log
      draw();
      raf = vr.request(tick);
    }

    // Pre-remplissage : le sismogramme est deja trace des la 1re frame (jamais
    // plat), avec une secousse garantie. Utile aussi si l'animation est bridee.
    qmag = 0.42; qdur = 2.8; qt = qdur; quaking = true;
    for (var pf = 0; pf < N + 30; pf++) {
      var tg = seismo(0.03);
      cur += (tg - cur) * (quaking ? 0.8 : 0.6);
      buf.push(clamp(cur, 0, 1)); if (buf.length > N) buf.shift();
    }
    draw();
    // Le sismographe est le coeur anime de la vitrine : il defile en continu
    // (translation horizontale douce, sans risque vestibulaire).
    raf = vr.request(tick);

    var api = {
      set: function (v) { level = clamp(num(v, 0.5), 0, 1); if (!raf) raf = vr.request(tick); return api; },
      feed: function (v) { return api.set(v); },
      // provoque une secousse tellurique a la demande (magnitude 0..1)
      quake: function (m) { qmag = 0.30 + clamp(num(m, 0.5), 0, 1) * 0.4; qdur = 2.4 + Math.random() * 2.4; qt = qdur; quaking = true; level = null; if (!raf && !REDUCE) raf = vr.request(tick); return api; },
      config: function (o) { draw(); return api; },
      redraw: draw
    };
    return api;
  }

  /* ---- Compteur a rouleaux (odometre mecanique) ----------------------- */
  function rollcounter(canvas, opts) {
    opts = opts || {};
    var digits = Math.max(1, num(opts.digits, 6) | 0);
    var value = Math.max(0, num(opts.value, 0));
    var rate = num(opts.rate, 0);                 // increment par seconde (auto)
    var b = fit(canvas), g = b.g, W = b.w, H = b.h;
    var raf = 0, last = nowMs(), vr = visibleRaf(canvas);

    function draw() {
      g.clearRect(0, 0, W, H);
      // cadre laiton
      g.fillStyle = '#1a140a'; g.fillRect(0, 0, W, H);
      g.strokeStyle = '#c9a24a'; g.lineWidth = 3; g.strokeRect(3, 3, W - 6, H - 6);
      var gap = 4, dw = (W - 16 - gap * (digits - 1)) / digits;
      var dh = H - 20, top = 10;
      for (var i = 0; i < digits; i++) {
        var col = digits - 1 - i;                 // 0 = unites (a droite)
        var x = 8 + i * (dw + gap);
        // fenetre du rouleau
        g.fillStyle = '#f5f0e6'; g.fillRect(x, top, dw, dh);
        g.strokeStyle = '#8a7a4a'; g.lineWidth = 1; g.strokeRect(x, top, dw, dh);
        // valeur affichee sur ce rouleau
        var place = value / Math.pow(10, col);
        var d = Math.floor(place) % 10;
        var f = place - Math.floor(place);
        // ne roule que dans les derniers 15 % (sensation mecanique)
        var off = f > 0.85 ? (f - 0.85) / 0.15 : 0;
        g.save();
        g.beginPath(); g.rect(x, top, dw, dh); g.clip();
        g.fillStyle = '#1a140a'; g.font = 'bold ' + Math.round(dh * 0.72) + 'px ui-monospace,monospace';
        g.textAlign = 'center'; g.textBaseline = 'middle';
        var cyc = top + dh / 2 + off * dh;
        g.fillText(((d) % 10) + '', x + dw / 2, cyc);
        g.fillText(((d + 1) % 10) + '', x + dw / 2, cyc - dh);
        g.restore();
        // separation ombree
        g.fillStyle = 'rgba(0,0,0,.18)'; g.fillRect(x, top, dw, 3); g.fillRect(x, top + dh - 3, dw, 3);
      }
    }
    function tick() {
      var t = nowMs(), dt = Math.min(0.1, (t - last) / 1000); last = t;
      if (rate) value += rate * dt;
      draw();
      raf = (rate && !REDUCE) ? vr.request(tick) : 0;
    }
    draw();
    if (rate && !REDUCE) { last = nowMs(); raf = vr.request(tick); }

    var api = {
      set: function (v) { value = Math.max(0, num(v, value)); draw(); return api; },
      value: function () { return value; },
      config: function (o) { if (o) { if ('rate' in o) rate = num(o.rate, rate); if ('digits' in o) digits = num(o.digits, digits) | 0; } if (rate && !raf && !REDUCE) { last = nowMs(); raf = vr.request(tick); } draw(); return api; },
      redraw: draw
    };
    return api;
  }

  /* ---- Rotametre (tube vertical a flotteur) ---------------------------- */
  function rotameter(canvas, opts) {
    opts = opts || {};
    var maxV = num(opts.max, 120), unit = opts.unit || '';
    var target = clamp(num(opts.value, 0), 0, maxV), shown = target;
    var b = fit(canvas), g = b.g, W = b.w, H = b.h;
    var cx = W * 0.42, top = 14, bot = H - 26;
    var wTop = W * 0.30, wBot = W * 0.14, raf = 0, t = 0, vr = visibleRaf(canvas);

    function frac(v) { return clamp(v, 0, maxV) / (maxV || 1); }
    function halfW(y) { var f = (y - top) / (bot - top); return (wBot + (wTop - wBot) * f) / 2; } // tube conique
    function draw() {
      g.clearRect(0, 0, W, H);
      g.fillStyle = '#0c1017'; g.fillRect(0, 0, W, H);
      // tube en verre conique
      g.beginPath();
      g.moveTo(cx - halfW(top), top); g.lineTo(cx - halfW(bot), bot);
      g.lineTo(cx + halfW(bot), bot); g.lineTo(cx + halfW(top), top); g.closePath();
      var tg = g.createLinearGradient(cx - wTop / 2, 0, cx + wTop / 2, 0);
      tg.addColorStop(0, '#1b232c'); tg.addColorStop(0.5, '#243039'); tg.addColorStop(1, '#12181f');
      g.fillStyle = tg; g.fill();
      g.strokeStyle = '#3a4653'; g.lineWidth = 1.5; g.stroke();
      // graduations
      g.strokeStyle = '#5a6a7e'; g.fillStyle = '#8fa2bd';
      g.font = '8px ui-monospace,monospace'; g.textAlign = 'left'; g.textBaseline = 'middle';
      for (var i = 0; i <= 6; i++) {
        var v = maxV * i / 6, y = bot - frac(v) * (bot - top);
        g.beginPath(); g.moveTo(cx + halfW(y), y); g.lineTo(cx + halfW(y) + 6, y); g.lineWidth = 1; g.stroke();
        g.fillText(Math.round(v) + '', cx + halfW(y) + 9, y);
      }
      // flotteur (bille metallique) qui flotte avec un leger tremblement
      var wob = frac(shown) > 0.01 ? Math.sin(t * 6) * 1.4 : 0;
      var fy = bot - frac(shown) * (bot - top) + wob;
      var fr = halfW(fy) * 0.8;
      var fg = g.createRadialGradient(cx - fr * 0.3, fy - fr * 0.3, fr * 0.1, cx, fy, fr);
      fg.addColorStop(0, '#f0f4ff'); fg.addColorStop(0.5, '#9fb0c4'); fg.addColorStop(1, '#3a4653');
      g.beginPath(); g.arc(cx, fy, fr, 0, TAU); g.fillStyle = fg; g.fill();
      g.strokeStyle = '#2a333d'; g.lineWidth = 1; g.stroke();
      // afficheur
      g.fillStyle = '#b6ff3b'; g.font = 'bold 11px ui-monospace,monospace';
      g.textAlign = 'center'; g.textBaseline = 'alphabetic';
      g.fillText(Math.round(shown) + (unit ? ' ' + unit : ''), W / 2, H - 6);
    }
    function tick() {
      t += 0.08;
      shown += (target - shown) * 0.12;
      var moving = Math.abs(target - shown) > maxV * 0.002;
      if (!moving) shown = target;
      draw();
      // continue a « frissonner » tant qu'il y a du debit
      if ((moving || frac(shown) > 0.01) && !REDUCE) raf = vr.request(tick); else raf = 0;
    }
    draw();
    if (frac(shown) > 0.01 && !REDUCE) raf = vr.request(tick);
    var api = {
      set: function (v) { target = clamp(num(v, target), 0, maxV); if (!raf && !REDUCE) raf = vr.request(tick); else if (REDUCE) { shown = target; draw(); } return api; },
      value: function () { return target; },
      config: function (o) { if (o) { if ('max' in o) maxV = num(o.max, maxV); if ('unit' in o) unit = o.unit; } draw(); return api; },
      redraw: draw
    };
    return api;
  }

  /* ---- Bande perforee de teletype (theme terminal) --------------------- */
  // Chaque colonne code un caractere sur 8 pistes (bit 7 en haut), avec la
  // piste d'entrainement entre les bits 3 et 2 comme sur une bande ECMA-10.
  // La bande defile de droite a gauche sous une tete de lecture qui decode le
  // texte au fil de l'eau. set(texte) charge un nouveau message.
  function punchtape(canvas, opts) {
    opts = opts || {};
    var color = opts.color || '#33ff66', speed = num(opts.speed, 1);
    var text = String(opts.text || 'SYNAPX PANEL ');
    var b = fit(canvas), g = b.g, W = b.w, H = b.h;
    var pitch = 10, tapeTop = 8, tapeH = H - 34, rowH = tapeH / 9; // 8 pistes + entrainement
    var offset = 0, raf = 0, last = nowMs(), vr = visibleRaf(canvas);
    var hx = Math.round(W * 0.62);           // tete de lecture

    function hole(x, y, r) { g.beginPath(); g.arc(x, y, r, 0, TAU); g.fill(); }
    function rowOf(bit) { return bit >= 3 ? 7 - bit : 8 - bit; }
    function draw() {
      g.clearRect(0, 0, W, H);
      g.fillStyle = '#020806'; g.fillRect(0, 0, W, H);
      // le papier
      g.fillStyle = 'rgba(51,255,102,.07)'; g.fillRect(0, tapeTop, W, tapeH);
      g.strokeStyle = 'rgba(51,255,102,.35)'; g.lineWidth = 1;
      g.beginPath(); g.moveTo(0, tapeTop + .5); g.lineTo(W, tapeTop + .5);
      g.moveTo(0, tapeTop + tapeH - .5); g.lineTo(W, tapeTop + tapeH - .5); g.stroke();
      // les trous : colonne j a l'abscisse j*pitch - offset
      var n = text.length, j0 = Math.floor(offset / pitch), j1 = Math.ceil((offset + W) / pitch);
      g.fillStyle = color; g.shadowColor = color; g.shadowBlur = 5;
      for (var j = j0; j <= j1; j++) {
        var x = j * pitch - offset, code = text.charCodeAt(((j % n) + n) % n) & 255;
        for (var bit = 0; bit < 8; bit++) {
          if (code & (1 << bit)) hole(x, tapeTop + rowH * (rowOf(bit) + .5), rowH * .32);
        }
        hole(x, tapeTop + rowH * 5.5, rowH * .15); // entrainement
      }
      g.shadowBlur = 0;
      // tete de lecture
      g.strokeStyle = color; g.globalAlpha = .55; g.lineWidth = 1;
      g.beginPath(); g.moveTo(hx + .5, 2); g.lineTo(hx + .5, tapeTop + tapeH + 4); g.stroke();
      g.globalAlpha = 1;
      g.beginPath(); g.moveTo(hx - 4, 2); g.lineTo(hx + 4, 2); g.lineTo(hx, 6); g.closePath(); g.fillStyle = color; g.fill();
      // decodage : les caracteres passes sous la tete
      var head = Math.round((offset + hx) / pitch), out = '';
      for (var k = head - 22; k <= head; k++) out += text.charAt(((k % n) + n) % n);
      g.font = 'bold 11px ui-monospace,monospace'; g.textAlign = 'left'; g.textBaseline = 'alphabetic';
      g.fillStyle = color; g.globalAlpha = .55; g.fillText('>', 6, H - 8); g.globalAlpha = 1;
      g.fillText(out, 18, H - 8);
      var cw = g.measureText(out).width;
      if (Math.floor(nowMs() / 500) % 2) g.fillRect(18 + cw + 2, H - 17, 6, 11); // curseur
    }
    function tick() {
      var t = nowMs(); offset += (t - last) * 0.04 * speed; last = t;
      if (offset > text.length * pitch * 1e3) offset -= text.length * pitch * 1e3;
      draw();
      raf = REDUCE ? 0 : vr.request(tick);
    }
    draw();
    if (!REDUCE) raf = vr.request(tick);
    var api = {
      set: function (v) { text = String(v == null ? '' : v) || ' '; if (!/\s$/.test(text)) text += ' '; draw(); return api; },
      value: function () { return text; },
      config: function (o) { if (o) { if ('speed' in o) speed = num(o.speed, speed); if (o.color) color = o.color; } draw(); return api; },
      start: function () { if (!raf && !REDUCE) { last = nowMs(); raf = vr.request(tick); } return api; },
      stop: function () { if (raf) vr.cancel(raf); raf = 0; return api; },
      redraw: draw
    };
    return api;
  }

  /* ---- Cascade spectrale ASCII (theme terminal) ------------------------ */
  // Le « waterfall » d'un recepteur SDR ecrit en caracteres : chaque ligne est
  // un spectre code par une rampe de densite ( .:-=+*#%@), les lignes
  // descendent au fil du temps. Sans donnees, une porteuse synthetique derive
  // dans le bruit ; feed(tableau 0..1) pousse une ligne reelle.
  function waterfall(canvas, opts) {
    opts = opts || {};
    var color = opts.color || '#33ff66', cols = Math.max(8, num(opts.cols, 32) | 0);
    var ramp = opts.ramp || ' .:-=+*#%@';
    var carrier = clamp(num(opts.carrier, 0.5), 0, 1), gain = clamp(num(opts.gain, 0.8), 0, 1);
    var b = fit(canvas), g = b.g, W = b.w, H = b.h;
    var rowH = 9, top = 16, rows = Math.max(1, Math.floor((H - top - 4) / rowH)), cellW = W / cols;
    var lines = [], t = 0, fed = null, raf = 0, acc = 0, last = nowMs(), vr = visibleRaf(canvas);

    function synth() {
      var row = new Array(cols), c = carrier + Math.sin(t * 0.7) * 0.15, c2 = (c * 2) % 1;
      for (var i = 0; i < cols; i++) {
        var f = (i + .5) / cols;
        var v = Math.random() * 0.16
          + gain * Math.exp(-Math.pow((f - c) * cols / 1.6, 2))
          + gain * 0.45 * Math.exp(-Math.pow((f - c2) * cols / 1.2, 2));
        if (Math.random() < 0.015) v += 0.5; // parasite
        row[i] = clamp(v, 0, 1);
      }
      return row;
    }
    function push(row) { lines.unshift(row); if (lines.length > rows) lines.length = rows; }
    function draw() {
      g.clearRect(0, 0, W, H);
      g.fillStyle = '#020806'; g.fillRect(0, 0, W, H);
      g.font = 'bold 9px ui-monospace,monospace'; g.textAlign = 'center'; g.textBaseline = 'middle';
      // regle de frequence
      g.fillStyle = color; g.globalAlpha = .5;
      for (var i = 0; i < cols; i++) g.fillText(i % 8 === 0 ? '+' : '-', (i + .5) * cellW, 7);
      g.globalAlpha = 1;
      for (var r = 0; r < lines.length; r++) {
        var row = lines[r], fade = 1 - (r / rows) * 0.65, y = top + r * rowH + rowH / 2;
        for (var c = 0; c < cols; c++) {
          var v = row[c], ch = ramp.charAt(Math.min(ramp.length - 1, Math.floor(v * ramp.length)));
          if (ch === ' ') continue;
          g.globalAlpha = (0.25 + 0.75 * v) * fade;
          g.fillText(ch, (c + .5) * cellW, y);
        }
      }
      g.globalAlpha = 1;
    }
    function tick() {
      var n = nowMs(); acc += n - last; last = n;
      var drew = false;
      while (acc > 110) { acc -= 110; t += 0.11; push(fed || synth()); fed = null; drew = true; }
      if (drew) draw();
      raf = REDUCE ? 0 : vr.request(tick);
    }
    for (var i = 0; i < rows; i++) { t += 0.11; push(synth()); }
    draw();
    if (!REDUCE) raf = vr.request(tick);
    var api = {
      set: function (v) {
        if (v && v.length !== undefined && typeof v !== 'string') return api.feed(v);
        if (v && typeof v === 'object') api.config(v); else carrier = clamp(num(v, carrier), 0, 1);
        return api;
      },
      feed: function (row) {
        var out = new Array(cols);
        for (var i = 0; i < cols; i++) out[i] = clamp(num(row[Math.floor(i * row.length / cols)], 0), 0, 1);
        fed = out; if (REDUCE) { push(out); draw(); }
        return api;
      },
      value: function () { return carrier; },
      config: function (o) { if (o) { if ('carrier' in o) carrier = clamp(num(o.carrier, carrier), 0, 1); if ('gain' in o) gain = clamp(num(o.gain, gain), 0, 1); if (o.color) color = o.color; } draw(); return api; },
      start: function () { if (!raf && !REDUCE) { last = nowMs(); raf = vr.request(tick); } return api; },
      stop: function () { if (raf) vr.cancel(raf); raf = 0; return api; },
      redraw: draw
    };
    return api;
  }

  /* ---- Auto-init ------------------------------------------------------ */
  function parseZones(s) {
    if (!s) return [];
    return s.split(';').map(function (p) {
      var m = p.split(',');
      return { from: parseFloat(m[0]), to: parseFloat(m[1]), color: (m[2] || '#33ff66').trim() };
    });
  }
  function build(canvas) {
    if (canvas.dataset.sxpReady) return;
    canvas.dataset.sxpReady = '1';
    var d = canvas.dataset, kind = d.inst;
    if (kind === 'radar') {
      canvas._sxp = radar(canvas, {
        speed: num(d.speed, 0.028), gain: num(d.gain, 0.7),
        persist: num(d.persist, 0.6), range: num(d.range, 0.7), color: d.color
      });
      canvas._sxp.start();
      return;
    }
    if (kind === 'oscilloscope') {
      canvas._sxp = scope(canvas, {
        wave: d.wave, freq: num(d.freq, 2), amp: num(d.amp, 0.7), color: d.color,
        sweep: num(d.sweep, 0.5), intensity: num(d.intensity, 0.8), focus: num(d.focus, 0.7),
        disp: d.disp || 'line', power: d.power !== 'false'
      });
      canvas._sxp.start();
      return;
    }
    // ── Instruments de mesure vintage (Phase 3) ──
    if (kind === 'geiger') { canvas._sxp = geiger(canvas, { value: num(d.val, 0.15), max: num(d.max, 30) }); return; }
    if (kind === 'compass') { canvas._sxp = compass(canvas, { value: num(d.val, 0) }); return; }
    if (kind === 'thermometer') { canvas._sxp = thermometer(canvas, { min: d.min, max: d.max, unit: d.unit, value: num(d.val, 20) }); return; }
    if (kind === 'vumeter') { canvas._sxp = vumeter(canvas, { value: num(d.val, 0) }); return; }
    if (kind === 'recorder') { canvas._sxp = recorder(canvas, {}); return; }
    if (kind === 'rollcounter') { canvas._sxp = rollcounter(canvas, { digits: num(d.digits, 6), value: num(d.val, 0), rate: num(d.rate, 0) }); return; }
    if (kind === 'rotameter') { canvas._sxp = rotameter(canvas, { max: num(d.max, 120), unit: d.unit, value: num(d.val, 0) }); return; }
    // ── Theme terminal ──
    if (kind === 'punchtape') { canvas._sxp = punchtape(canvas, { text: d.text, speed: num(d.speed, 1), color: d.color }); return; }
    if (kind === 'waterfall') { canvas._sxp = waterfall(canvas, { cols: num(d.cols, 32), carrier: num(d.carrier, 0.5), gain: num(d.gain, 0.8), color: d.color }); return; }
    canvas._sxp = gauge(canvas, {
      min: d.min, max: d.max, value: d.val, unit: d.unit, label: d.label,
      accent: d.accent, decimals: d.decimals, majorTicks: d.majors, minorTicks: d.minors,
      zones: parseZones(d.zones), startDeg: d.startDeg, endDeg: d.endDeg
    });
  }
  function init(root) {
    (root || document).querySelectorAll('canvas.sxp-inst').forEach(build);
  }

  var api = global.SxpPanel || (global.SxpPanel = {});
  api.gauge = gauge; api.scope = scope; api.radar = radar; api.initInstruments = init;
  api.geiger = geiger; api.compass = compass; api.thermometer = thermometer;
  api.vumeter = vumeter; api.recorder = recorder; api.rollcounter = rollcounter; api.rotameter = rotameter;
  api.punchtape = punchtape; api.waterfall = waterfall;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else { init(document); }
})(window);

/* ==========================================================================
   Synapx Panel — Phase 2bis : assemblages « poste de vol ».
     - SxpPanel.stick(host, opts)   : manche a balai + manette des gaz.
     - SxpPanel.cockpit(host, opts) : cluster d'instruments de vol (horizon,
                                      variometre, compas, altimetre, badin).
   Generalise et anonymise depuis les commandes de vol de reference.
   Auto-init : <div class="sxp-stick"> et <div class="sxp-cockpit" data-dials="...">
   ========================================================================== */
(function (global) {
  'use strict';
  var TAU = Math.PI * 2, DEG = Math.PI / 180;
  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
  function num(v, d) { v = parseFloat(v); return isNaN(v) ? d : v; }
  // Butee circulaire : ramene un point dans le disque unite (course du manche).
  function disk(x, y) { var m = Math.hypot(x, y); return m > 1 ? { x: x / m, y: y / m } : { x: x, y: y }; }
  // rAF conditionne a la visibilite (helper de panel.js) ; repli natif sans panel.js.
  function visibleRaf(el) {
    var f = global.SxpPanel && global.SxpPanel.visibleRaf;
    return f ? f(el) : {
      request: function (fn) { return global.requestAnimationFrame(fn); },
      cancel: function (id) { global.cancelAnimationFrame(id); }
    };
  }

  /* ---- Manche a balai + gaz ------------------------------------------- */
  function stick(host, opts) {
    opts = opts || {};
    host.classList.add('sxp-stick');
    host.innerHTML =
      '<div class="sxp-stick-pad" role="slider" tabindex="0" aria-label="' + (opts.stickLabel || 'Manche') + '">' +
        '<span class="sxp-stick-cross"></span><span class="sxp-stick-grip"></span></div>' +
      '<div class="sxp-stick-throttle" role="slider" tabindex="0" aria-valuemin="0" aria-valuemax="100" ' +
           'aria-label="' + (opts.throttleLabel || 'Gaz') + '">' +
        '<span class="sxp-stick-rail"></span><span class="sxp-stick-lever"></span></div>' +
      '<span class="sxp-stick-name">' + (opts.label || 'POSTE DE VOL') + '</span>';

    var pad = host.querySelector('.sxp-stick-pad'), grip = host.querySelector('.sxp-stick-grip');
    var thr = host.querySelector('.sxp-stick-throttle'), lever = host.querySelector('.sxp-stick-lever');
    var jx = 0, jy = 0, gaz = 0, heldStick = false, heldThr = false, cb = opts.onInput || null;
    function emit() { if (cb) cb({ x: jx, y: jy, throttle: gaz }); }

    function paintStick(x, y) {
      if (x === undefined) { x = jx; y = jy; }
      var R = pad.clientWidth / 2 - grip.offsetWidth / 2 - 3;
      grip.style.transform = 'translate(' + (x * R) + 'px,' + (-y * R) + 'px)';
      grip.classList.toggle('is-active', !!(x || y));
    }
    function setStick(e) {
      var r = pad.getBoundingClientRect(), R = r.width / 2 - 6;
      var p = disk((e.clientX - r.left - r.width / 2) / R, -(e.clientY - r.top - r.height / 2) / R);
      jx = p.x; jy = p.y; paintStick(); emit();
    }
    pad.addEventListener('pointerdown', function (e) { heldStick = true; pad.setPointerCapture(e.pointerId); setStick(e); e.preventDefault(); });
    pad.addEventListener('pointermove', function (e) { if (heldStick) setStick(e); });
    function releaseStick() { if (!heldStick) return; heldStick = false; jx = 0; jy = 0; paintStick(); emit(); }
    pad.addEventListener('pointerup', releaseStick);
    pad.addEventListener('pointercancel', releaseStick);
    pad.addEventListener('keydown', function (e) {
      var m = { ArrowLeft: [-1, 0], ArrowRight: [1, 0], ArrowUp: [0, 1], ArrowDown: [0, -1] }[e.key];
      if (!m) return; jx = m[0] * 0.7; jy = m[1] * 0.7; paintStick(); emit(); e.preventDefault();
    });
    pad.addEventListener('keyup', function () { jx = 0; jy = 0; paintStick(); emit(); });

    function paintThr(g) {
      if (g === undefined) g = gaz;
      var H = thr.clientHeight - lever.offsetHeight - 6;
      lever.style.bottom = (3 + g * H) + 'px';
      lever.classList.toggle('is-active', g > 0);
      thr.setAttribute('aria-valuenow', Math.round(g * 100));
    }
    function setThr(e) { var r = thr.getBoundingClientRect(); gaz = clamp(1 - (e.clientY - r.top) / r.height, 0, 1); paintThr(); emit(); }
    thr.addEventListener('pointerdown', function (e) { heldThr = true; thr.setPointerCapture(e.pointerId); setThr(e); e.preventDefault(); });
    thr.addEventListener('pointermove', function (e) { if (heldThr) setThr(e); });
    function releaseThr() { heldThr = false; }         // friction : le levier reste
    thr.addEventListener('pointerup', releaseThr);
    thr.addEventListener('pointercancel', releaseThr);
    thr.addEventListener('wheel', function (e) { e.preventDefault(); gaz = clamp(gaz + (e.deltaY < 0 ? 0.05 : -0.05), 0, 1); paintThr(); emit(); }, { passive: false });
    thr.addEventListener('keydown', function (e) {
      var d = (e.key === 'ArrowUp' || e.key === '+') ? 0.1 : (e.key === 'ArrowDown' || e.key === '-') ? -0.1 : 0;
      if (!d) return; gaz = clamp(gaz + d, 0, 1); paintThr(); emit(); e.preventDefault();
    });
    paintThr();

    return {
      x: function () { return jx; }, y: function () { return jy; }, throttle: function () { return gaz; },
      onInput: function (fn) { cb = fn; return this; },
      cutThrottle: function () { gaz = 0; paintThr(); emit(); },
      show: function (x, y, g) { if (!heldStick) paintStick(clamp(x, -1, 1), clamp(y, -1, 1)); if (!heldThr && g != null) { gaz = clamp(g, 0, 1); paintThr(); } }
    };
  }

  /* ---- Cluster d'instruments de vol ----------------------------------- */
  function cockpit(host, opts) {
    opts = opts || {};
    host.classList.add('sxp-cockpit');
    var dials = (opts.dials || 'horizon,vario,cap,alt,vitesse').split(',').map(function (s) { return s.trim(); });
    var size = num(opts.size, 92);
    var NAMES = { horizon: 'horizon', vario: 'vario', cap: 'cap', alt: 'alt', vitesse: 'vitesse' };
    host.innerHTML = dials.map(function (d) {
      return '<div class="sxp-cockpit-inst"><canvas width="' + size + '" height="' + size + '"></canvas><span>' + (NAMES[d] || d) + '</span></div>';
    }).join('');
    var ctx = {};
    host.querySelectorAll('canvas').forEach(function (c, i) { ctx[dials[i]] = c.getContext('2d'); c._dpr = fit(c, size); });

    // etat lisse (inertie des instruments reels)
    var st = { pitch: 0, roll: 0, vario: 0, cap: 0, alt: 0, speed: 0 };
    var tg = { pitch: 0, roll: 0, vario: 0, cap: 0, alt: 0, speed: 0 };
    var raf = 0, vr = visibleRaf(host);

    function fit(c, W) {
      var dpr = Math.min(global.devicePixelRatio || 1, 2.5);
      c.width = W * dpr; c.height = W * dpr; c.style.width = W + 'px'; c.style.height = W + 'px';
      c.getContext('2d').setTransform(dpr, 0, 0, dpr, 0, 0);
      return dpr;
    }
    var W = size, C = W / 2, R = C - 3;

    function dial(g) { g.clearRect(0, 0, W, W); g.save(); g.beginPath(); g.arc(C, C, R, 0, TAU); g.clip(); g.fillStyle = '#0c1017'; g.fillRect(0, 0, W, W); }
    function bezel(g) { g.restore(); g.beginPath(); g.arc(C, C, R, 0, TAU); g.strokeStyle = '#5a6a7e'; g.lineWidth = 2.5; g.stroke(); g.beginPath(); g.arc(C, C, R - 1.8, 0, TAU); g.strokeStyle = '#12161d'; g.lineWidth = 1; g.stroke(); }

    function horizon() {
      var g = ctx.horizon; if (!g) return; dial(g);
      g.translate(C, C); g.rotate(st.roll);
      var off = st.pitch / (Math.PI / 2) * R * 1.15;
      g.fillStyle = '#274a72'; g.fillRect(-W, -W * 2 + off, W * 2, W * 2);
      g.fillStyle = '#5a3a1a'; g.fillRect(-W, off, W * 2, W * 2);
      g.strokeStyle = '#e8f0ff'; g.lineWidth = 1.6; g.beginPath(); g.moveTo(-W, off); g.lineTo(W, off); g.stroke();
      g.strokeStyle = 'rgba(232,240,255,.55)'; g.lineWidth = 1;
      [15, 30].forEach(function (d) { var y = d / 90 * R * 1.15;[-1, 1].forEach(function (s) { g.beginPath(); g.moveTo(-10, off + s * y); g.lineTo(10, off + s * y); g.stroke(); }); });
      g.rotate(-st.roll); g.translate(-C, -C);
      g.strokeStyle = '#ffd24a'; g.lineWidth = 2.4; g.lineCap = 'round';
      g.beginPath(); g.moveTo(C - 22, C); g.lineTo(C - 8, C); g.lineTo(C - 4, C + 4); g.stroke();
      g.beginPath(); g.moveTo(C + 22, C); g.lineTo(C + 8, C); g.lineTo(C + 4, C + 4); g.stroke();
      g.fillStyle = '#ffd24a'; g.beginPath(); g.arc(C, C, 1.8, 0, TAU); g.fill(); bezel(g);
    }
    function needleDial(g, frac, txt, aroundLeft) {
      dial(g); g.strokeStyle = '#5a6a7e'; g.lineWidth = 1;
      for (var i = 0; i <= 8; i++) {
        var a = aroundLeft ? (Math.PI + (i - 4) / 4 * (Math.PI * 0.75)) : ((-135 + i * 33.75 - 90) * DEG);
        var r0 = i % 2 ? R - 7 : R - 11;
        g.beginPath(); g.moveTo(C + Math.cos(a) * r0, C + Math.sin(a) * r0); g.lineTo(C + Math.cos(a) * (R - 4), C + Math.sin(a) * (R - 4));
        g.strokeStyle = (aroundLeft && i === 4) ? '#8fa2bd' : '#5a6a7e'; g.stroke();
      }
      var na = aroundLeft ? (Math.PI + clamp(frac, -1, 1) * (Math.PI * 0.75)) : ((-135 + clamp(frac, 0, 1) * 270 - 90) * DEG);
      g.strokeStyle = '#e8f0ff'; g.lineWidth = 2.2; g.lineCap = 'round';
      g.beginPath(); g.moveTo(C, C); g.lineTo(C + Math.cos(na) * (R - 12), C + Math.sin(na) * (R - 12)); g.stroke();
      g.strokeStyle = '#ff8a3a'; g.lineWidth = 2.6;
      g.beginPath(); g.moveTo(C + Math.cos(na) * (R - 20), C + Math.sin(na) * (R - 20)); g.lineTo(C + Math.cos(na) * (R - 12), C + Math.sin(na) * (R - 12)); g.stroke();
      if (txt != null) { g.fillStyle = '#c2d0e2'; g.font = '9px ui-monospace,monospace'; g.textAlign = 'center'; g.fillText(txt, C, C + R * 0.55); }
      g.fillStyle = '#5a6a7e'; g.beginPath(); g.arc(C, C, 3, 0, TAU); g.fill(); bezel(g);
    }
    function compass() {
      var g = ctx.cap; if (!g) return; dial(g); g.translate(C, C); g.rotate(-st.cap);
      var pts = ['N', 'E', 'S', 'O'];
      for (var i = 0; i < 12; i++) {
        var a = i * Math.PI / 6 - Math.PI / 2, maj = i % 3 === 0;
        g.strokeStyle = maj ? '#dbe5f2' : '#5a6a7e'; g.lineWidth = maj ? 1.6 : 1;
        g.beginPath(); g.moveTo(Math.cos(a) * (R - (maj ? 12 : 8)), Math.sin(a) * (R - (maj ? 12 : 8))); g.lineTo(Math.cos(a) * (R - 4), Math.sin(a) * (R - 4)); g.stroke();
        if (maj) { g.fillStyle = pts[i / 3] === 'N' ? '#ff8a3a' : '#c9d4e4'; g.font = 'bold 10px ui-monospace,monospace'; g.textAlign = 'center'; g.textBaseline = 'middle'; g.fillText(pts[i / 3], Math.cos(a) * (R - 20), Math.sin(a) * (R - 20)); }
      }
      g.rotate(st.cap); g.translate(-C, -C);
      g.strokeStyle = '#ffd24a'; g.lineWidth = 2; g.beginPath(); g.moveTo(C, 5); g.lineTo(C, 15); g.stroke();
      g.fillStyle = '#ffd24a'; g.beginPath(); g.arc(C, C, 1.8, 0, TAU); g.fill(); bezel(g);
    }

    function render() {
      horizon();
      if (ctx.vario) needleDial(ctx.vario, st.vario, null, true);
      compass();
      if (ctx.alt) needleDial(ctx.alt, st.alt, Math.round(st.alt * 1000) + '');
      if (ctx.vitesse) needleDial(ctx.vitesse, st.speed, Math.round(st.speed * 600) + '');
    }
    function tick() {
      var moving = false;
      ['pitch', 'roll', 'vario', 'cap', 'alt', 'speed'].forEach(function (k) {
        st[k] += (tg[k] - st[k]) * 0.18; if (Math.abs(tg[k] - st[k]) > 1e-4) moving = true; else st[k] = tg[k];
      });
      render(); raf = moving ? vr.request(tick) : 0;
    }
    render();

    return {
      set: function (s) {
        s = s || {};
        if ('pitch' in s) tg.pitch = num(s.pitch, tg.pitch) * DEG;
        if ('roll' in s) tg.roll = num(s.roll, tg.roll) * DEG;
        if ('heading' in s) tg.cap = num(s.heading, tg.cap / DEG) * DEG;
        if ('vario' in s) tg.vario = clamp(num(s.vario, tg.vario), -1, 1);
        if ('alt' in s) tg.alt = clamp(num(s.alt, tg.alt), 0, 1);
        if ('speed' in s) tg.speed = clamp(num(s.speed, tg.speed), 0, 1);
        if (!raf) raf = vr.request(tick);
        return this;
      }
    };
  }

  /* ---- Auto-init ------------------------------------------------------ */
  function init(root) {
    root = root || document;
    root.querySelectorAll('.sxp-stick').forEach(function (h) {
      if (h.dataset.sxpReady) return; h.dataset.sxpReady = '1';
      h._sxp = stick(h, { label: h.dataset.label, stickLabel: h.dataset.stick, throttleLabel: h.dataset.throttle });
    });
    root.querySelectorAll('.sxp-cockpit').forEach(function (h) {
      if (h.dataset.sxpReady) return; h.dataset.sxpReady = '1';
      h._sxp = cockpit(h, { dials: h.dataset.dials, size: h.dataset.size });
    });
  }
  var api = global.SxpPanel || (global.SxpPanel = {});
  api.stick = stick; api.cockpit = cockpit; api.initCockpit = init;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else { init(document); }
})(window);

/* ==========================================================================
   Synapx Panel — Facade API orientee objet (zero dependance).
   Constructeurs fins « new SXP.Panel.Xxx(selecteur, opts) » qui resolvent
   l'element et s'appuient sur les primitives SxpPanel.* (canvas) ou sur
   el._sxp (controles). Exposent .set() / .on() / .feed() selon l'instrument.
   Ne casse rien si l'element est absent (methodes muettes).
   ========================================================================== */
(function (global) {
  'use strict';

  var SXP = global.SXP || (global.SXP = {});
  var SP = global.SxpPanel || {};

  function resolve(sel) {
    if (!sel) return null;
    if (sel.nodeType === 1) return sel;
    try { return document.querySelector(sel); } catch (e) { return null; }
  }
  // Objet muet : toute methode renvoie l'instance, aucune erreur.
  function noop() { return this; }

  /* Instrument canvas : (re)construit la primitive sur le canvas cible. */
  function canvasInst(sel, kind, opts, autostart) {
    var el = resolve(sel);
    if (!el || !SP[kind]) return null;
    // Si des options sont fournies, on reconstruit ; sinon on reutilise l'auto-init.
    if (opts || !el._sxp) { el.dataset.sxpReady = ''; el._sxp = SP[kind](el, opts || {}); }
    if (autostart && el._sxp && el._sxp.start) el._sxp.start();
    return el._sxp;
  }

  /* --- Fabrique generique pour les instruments a aiguille/afficheur ----- */
  function makeSimple(kind, autostart) {
    return function (sel, opts) {
      var inst = canvasInst(sel, kind, opts, autostart);
      this._i = inst;
      this.set = function (v) { if (inst && inst.set) inst.set(v); return this; };
      this.feed = function (v) { if (inst && (inst.feed || inst.set)) (inst.feed || inst.set)(v); return this; };
      this.config = function (o) { if (inst && inst.config) inst.config(o); return this; };
      this.start = function () { if (inst && inst.start) inst.start(); return this; };
      this.stop = function () { if (inst && inst.stop) inst.stop(); return this; };
      this.value = function () { return inst && inst.value ? inst.value() : undefined; };
      // Sismographe : secousse a la demande (magnitude 0..1)
      this.quake = function (m) { if (inst && inst.quake) inst.quake(m); return this; };
      this.el = inst;
    };
  }

  // Instruments a aiguille / afficheur : .set(), .config()
  SXP.Panel = SXP.Panel || {};
  var P = SXP.Panel;

  P.Gauge = makeSimple('gauge', false);
  P.Scope = makeSimple('scope', true);
  P.Radar = makeSimple('radar', true);
  P.Vumeter = makeSimple('vumeter', false);
  P.Compass = makeSimple('compass', false);
  P.Recorder = makeSimple('recorder', false);
  P.Geiger = makeSimple('geiger', false);
  P.Thermometer = makeSimple('thermometer', false);
  P.Rollcounter = makeSimple('rollcounter', false);
  P.Rotameter = makeSimple('rotameter', false);
  // Theme terminal : .set(texte) / .feed(spectre)
  P.Punchtape = makeSimple('punchtape', false);
  P.Waterfall = makeSimple('waterfall', false);

  /* --- Poste de vol ----------------------------------------------------- */
  P.Cockpit = function (sel, opts) {
    var el = resolve(sel);
    if (el && SP.cockpit && (!el._sxp || opts)) { el.dataset.sxpReady = '1'; el._sxp = SP.cockpit(el, opts || {}); }
    var inst = el && el._sxp;
    this.set = function (s) { if (inst && inst.set) inst.set(s); return this; };
    this.el = inst;
  };

  P.Stick = function (sel, opts) {
    var el = resolve(sel);
    if (el && SP.stick && (!el._sxp || opts)) { el.dataset.sxpReady = '1'; el._sxp = SP.stick(el, opts || {}); }
    var inst = el && el._sxp;
    this.onInput = function (fn) { if (inst && inst.onInput) inst.onInput(fn); return this; };
    this.x = function () { return inst && inst.x ? inst.x() : 0; };
    this.y = function () { return inst && inst.y ? inst.y() : 0; };
    this.throttle = function () { return inst && inst.throttle ? inst.throttle() : 0; };
    this.el = inst;
  };

  /* --- Controles (div) : knob, selecteur, egaliseur --------------------- */
  P.Knob = function (sel, opts) {
    var el = resolve(sel);
    if (el && SP.buildKnob) {
      if (opts) { // applique les options avant construction
        if ('min' in opts) el.dataset.min = opts.min;
        if ('max' in opts) el.dataset.max = opts.max;
        if ('step' in opts) el.dataset.step = opts.step;
        if ('val' in opts) el.dataset.val = opts.val;
      }
      if (!el.dataset.sxpReady) SP.buildKnob(el);
    }
    var inst = el && el._sxp;
    this.on = function (fn) { if (el) el.addEventListener('sxp:input', function (e) { fn(e.detail.value); }); return this; };
    this.value = function () { return inst && inst.value ? inst.value() : (el ? parseFloat(el.dataset.val) : 0); };
    // Pilotage externe : deplace reellement l'aiguille (sans re-emettre sxp:input).
    this.set = function (v) { if (inst && inst.set) inst.set(v); return this; };
    this.el = el;
  };

  P.Selector = function (sel) {
    var el = resolve(sel);
    if (el && SP.buildSelector && !el.dataset.sxpReady) SP.buildSelector(el);
    var inst = el && el._sxp;
    this.on = function (fn) { if (el) el.addEventListener('sxp:change', function (e) { fn(e.detail.value, e.detail.index); }); return this; };
    this.set = function (v) { if (inst && inst.select) inst.select(v); return this; };
    this.value = function () { return inst && inst.value ? inst.value() : null; };
    this.el = inst;
  };

  P.Equalizer = function (sel) {
    var el = resolve(sel);
    if (el && SP.buildEqualizer && !el.dataset.sxpReady) SP.buildEqualizer(el);
    var inst = el && el._sxp;
    this.feed = function (L) { if (inst && inst.feed) inst.feed(L); return this; };
    this.on = function (fn) { if (inst && inst.onFrame) inst.onFrame(fn); return this; };
    this.start = function () { if (inst && inst.start) inst.start(); return this; };
    this.stop = function () { if (inst && inst.stop) inst.stop(); return this; };
    this.el = inst;
  };

  // Garde-fou : si une classe est appelee sur un selecteur vide, elle reste muette.
  for (var key in P) {
    if (!P.hasOwnProperty(key)) continue;
    var proto = P[key].prototype;
    ['set', 'feed', 'on', 'config', 'start', 'stop', 'onInput'].forEach(function (m) {
      if (!(m in proto)) proto[m] = noop;
    });
  }
})(window);

/* ==========================================================================
   Synapx Panel — donnees « monde » pour le globe (zero dependance).
   Trace basse resolution des continents + champs simules (radiation, temperature)
   consommes par panel-globe.js pour piloter Geiger / thermometre / boussole.

     SXP.World.coastlines            : [ [ [lon,lat], ... ], ... ]  (degres)
     SXP.World.radiationAt(lat,lon)  : dose de fond + points chauds (µSv/h)
     SXP.World.tempAt(lat,lon)       : temperature approx (°C)
     SXP.World.place(lat,lon)        : libelle de la zone la plus proche
   ========================================================================== */
(function (global) {
  'use strict';

  var SXP = global.SXP || (global.SXP = {});

  /* ---- Traits de cote (tres schematiques, mais reconnaissables) --------
     Chaque polyligne est une suite de points [lon, lat] en degres. On vise la
     silhouette, pas la precision : quelques dizaines de points par continent. */
  var coastlines = [

    /* Afrique */
    [[-6, 36], [10, 37], [20, 32], [33, 31], [43, 12], [51, 12], [48, 5],
     [41, -2], [40, -10], [35, -20], [32, -26], [26, -34], [18, -34],
     [12, -18], [12, -8], [9, 0], [3, 6], [-8, 5], [-13, 9], [-17, 15],
     [-16, 21], [-13, 27], [-10, 31], [-6, 36]],

    /* Eurasie (silhouette continue Europe -> Siberie -> Asie du Sud -> Med.) */
    [[-9, 39], [-9, 43], [0, 49], [4, 52], [8, 54], [10, 58], [18, 59],
     [24, 60], [30, 63], [40, 66], [60, 69], [80, 73], [105, 77], [140, 73],
     [160, 70], [170, 68], [160, 60], [143, 52], [140, 46], [130, 43],
     [126, 35], [122, 31], [118, 24], [108, 21], [105, 10], [100, 7],
     [98, 16], [90, 22], [88, 21], [80, 13], [77, 8], [72, 20], [67, 25],
     [61, 25], [57, 26], [50, 30], [48, 30], [50, 25], [56, 22], [59, 22],
     [52, 16], [45, 13], [43, 15], [37, 28], [35, 31], [30, 31], [28, 36],
     [27, 40], [22, 40], [16, 41], [12, 45], [8, 44], [3, 43], [-2, 43],
     [-9, 39]],

    /* Amerique du Nord */
    [[-168, 66], [-162, 70], [-156, 71], [-140, 70], [-125, 70], [-100, 69],
     [-95, 68], [-82, 66], [-78, 62], [-80, 56], [-64, 60], [-60, 47],
     [-67, 45], [-70, 43], [-74, 40], [-76, 35], [-81, 31], [-82, 25],
     [-90, 29], [-97, 26], [-105, 23], [-110, 24], [-117, 32], [-122, 37],
     [-124, 42], [-124, 48], [-130, 54], [-140, 60], [-150, 60], [-160, 58],
     [-165, 60], [-168, 66]],

    /* Amerique du Sud */
    [[-81, 8], [-77, 1], [-79, -4], [-71, -18], [-70, -30], [-73, -42],
     [-73, -50], [-70, -54], [-65, -50], [-63, -42], [-58, -38], [-57, -34],
     [-53, -33], [-48, -26], [-42, -23], [-40, -20], [-35, -8], [-44, -2],
     [-50, 0], [-60, 6], [-70, 11], [-77, 9], [-81, 8]],

    /* Australie */
    [[115, -34], [123, -34], [129, -32], [138, -35], [147, -38], [150, -37],
     [153, -31], [153, -28], [148, -20], [145, -16], [141, -12], [136, -12],
     [130, -12], [126, -14], [122, -18], [114, -22], [113, -26], [115, -34]],

    /* Groenland */
    [[-45, 60], [-42, 66], [-32, 68], [-25, 70], [-20, 76], [-30, 82],
     [-45, 83], [-60, 80], [-58, 74], [-55, 68], [-50, 62], [-45, 60]],

    /* Iles Britanniques */
    [[-5, 50], [1, 51], [-1, 53], [-3, 55], [-5, 58], [-8, 57], [-10, 54],
     [-6, 52], [-5, 50]],

    /* Japon */
    [[130, 31], [132, 34], [136, 34], [139, 35], [141, 40], [142, 43],
     [141, 41], [140, 38], [137, 36], [135, 34], [131, 33], [130, 31]],

    /* Madagascar */
    [[49, -16], [50, -20], [47, -24], [44, -22], [44, -18], [46, -15], [49, -16]],

    /* Inde du Sud / Sri Lanka (petit rappel) */
    [[80, 6], [82, 8], [81, 9], [80, 8], [80, 6]]
  ];

  /* ---- Points chauds radiologiques ------------------------------------
     Chaque foyer : latitude, longitude, pic (µSv/h) et rayon sigma (degres).
     La dose vaut : fond + Σ pic * exp(-(d/sigma)²), d = distance angulaire. */
  var HOTSPOTS = [
    { name: 'ZONE TCHERNOBYL', lat: 51.39, lon: 30.10, peak: 25, sigma: 2.2 },
    { name: 'FUKUSHIMA', lat: 37.42, lon: 141.03, peak: 12, sigma: 2.6 }
  ];

  /* Distance angulaire approchee (degres), correcte pres du foyer. */
  function angDist(lat1, lon1, lat2, lon2) {
    var dLat = lat1 - lat2;
    var dLon = lon1 - lon2;
    if (dLon > 180) dLon -= 360; else if (dLon < -180) dLon += 360;
    var k = Math.cos((lat1 + lat2) * 0.5 * Math.PI / 180);
    dLon *= k;
    return Math.sqrt(dLat * dLat + dLon * dLon);
  }

  function radiationAt(lat, lon) {
    // Bruit de fond 0.10..0.18 µSv/h, module tres doucement par la position.
    var bg = 0.14 + 0.04 * Math.sin(lat * 0.7) * Math.cos(lon * 0.5);
    var dose = bg;
    for (var i = 0; i < HOTSPOTS.length; i++) {
      var h = HOTSPOTS[i];
      var d = angDist(lat, lon, h.lat, h.lon) / h.sigma;
      dose += h.peak * Math.exp(-d * d);
    }
    return dose;
  }

  function tempAt(lat, lon) {
    // Modele par latitude : chaud a l'equateur, froid aux poles.
    var t = 30 - 0.9 * Math.abs(lat);
    // Petite variation continentale/saisonniere deterministe (pas de hasard).
    t += 3 * Math.sin(lon * 0.3) * (1 - Math.abs(lat) / 90);
    return t;
  }

  /* Table de reperes : on renvoie le plus proche sous un rayon donne. */
  var PLACES = [
    { name: 'ZONE TCHERNOBYL', lat: 51.39, lon: 30.10, r: 4 },
    { name: 'FUKUSHIMA', lat: 37.42, lon: 141.03, r: 4 },
    { name: 'PARIS', lat: 48.85, lon: 2.35, r: 6 },
    { name: 'SIBERIE', lat: 66, lon: 100, r: 22 },
    { name: 'SAHARA', lat: 23, lon: 13, r: 16 },
    { name: 'AMAZONIE', lat: -5, lon: -63, r: 16 },
    { name: 'HIMALAYA', lat: 30, lon: 85, r: 10 },
    { name: 'AUSTRALIE', lat: -25, lon: 133, r: 18 },
    { name: 'ANTARCTIQUE', lat: -78, lon: 0, r: 40 },
    { name: 'ARCTIQUE', lat: 85, lon: 0, r: 30 }
  ];

  function place(lat, lon) {
    var best = null, bestD = 1e9;
    for (var i = 0; i < PLACES.length; i++) {
      var p = PLACES[i], d = angDist(lat, lon, p.lat, p.lon);
      if (d < p.r && d < bestD) { bestD = d; best = p; }
    }
    if (best) return best.name;
    return Math.abs(lat) > 60 ? (lat > 0 ? 'HAUTES LATITUDES N' : 'HAUTES LATITUDES S') : 'OCEAN / TERRE';
  }

  SXP.World = {
    coastlines: coastlines,
    radiationAt: radiationAt,
    tempAt: tempAt,
    place: place
  };
})(window);

/* ==========================================================================
   Synapx Panel — Globe terrestre orthographique (canvas 2D pur, zero dependance).
   Remplace l'ancienne implementation Three.js. Le globe est orientable a la
   souris / au doigt ; le point geographique SOUS le reticule central (lat0,lon0)
   pilote en direct : lecture LAT/LON, compteur Geiger, thermometre et boussole.

   Comportement cle : en zone irradiee (dose > seuil), le Geiger « crepite »
   (classe CSS .sxp-buzz sur son canvas) et la boussole s'affole (mode spin).
   Depend de SXP.World (panel-world.js) pour les cotes et les champs simules.
   ========================================================================== */
(function (global) {
  'use strict';

  var DEG = Math.PI / 180, TAU = Math.PI * 2;
  var REDUCE = global.matchMedia && global.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
  // rAF conditionne a la visibilite (helper de panel.js) ; repli natif sans panel.js.
  function visibleRaf(el) {
    var f = global.SxpPanel && global.SxpPanel.visibleRaf;
    return f ? f(el) : {
      request: function (fn) { return global.requestAnimationFrame(fn); },
      cancel: function (id) { global.cancelAnimationFrame(id); }
    };
  }

  /* ---- Son du compteur Geiger -----------------------------------------
     Clics « tic » (bruit filtre tres court) planifies en loi de Poisson :
     plus la dose est forte, plus les clics sont rapproches (crepitement).
     Web Audio 100 % local, aucune dependance. Debloque au 1er geste
     utilisateur (politique autoplay) : unlock() sur le drag du globe. */
  function makeGeigerAudio() {
    var ctx = null, rate = 2, timer = 0, on = false;
    function ensure() {
      if (ctx) return true;
      var AC = global.AudioContext || global.webkitAudioContext;
      if (!AC) return false;
      try { ctx = new AC(); } catch (e) { return false; }
      return true;
    }
    function play(vol) {
      var t = ctx.currentTime, sr = ctx.sampleRate, dur = 0.02;
      var n = Math.max(1, Math.floor(sr * dur));
      var buf = ctx.createBuffer(1, n, sr), d = buf.getChannelData(0);
      for (var i = 0; i < n; i++) d[i] = (Math.random() * 2 - 1) * Math.pow(1 - i / n, 10); // impulsion seche
      var src = ctx.createBufferSource(); src.buffer = buf;
      var bp = ctx.createBiquadFilter(); bp.type = 'bandpass'; bp.frequency.value = 2600; bp.Q.value = 0.7;
      var g = ctx.createGain(); g.gain.value = vol;
      src.connect(bp); bp.connect(g); g.connect(ctx.destination); src.start(t);
    }
    function schedule() {
      if (!on || !ctx) return;
      play(0.22 + Math.random() * 0.33);
      var mean = 1000 / Math.max(0.5, rate);                 // intervalle moyen (ms)
      var dt = -Math.log(1 - Math.random()) * mean;          // tirage exponentiel
      timer = global.setTimeout(schedule, clamp(dt, 8, 4000));
    }
    return {
      unlock: function () {
        if (!ensure()) return;
        if (ctx.state === 'suspended') ctx.resume();
        if (!on) { on = true; schedule(); }
      },
      // dose µSv/h -> cadence de clics/s (fond ~2/s, zone Tchernobyl ~80/s)
      setDose: function (uSvh) { rate = clamp(1.5 + (+uSvh || 0) * 3.2, 1.5, 90); }
    };
  }

  function build(host) {
    if (!host || host.dataset.sxpReady) return;
    host.dataset.sxpReady = '1';
    var World = (global.SXP && global.SXP.World) || null;
    if (!World) return;

    // Canvas insere AVANT les overlays (reticule, point, lecture).
    var canvas = document.createElement('canvas');
    host.insertBefore(canvas, host.firstChild);
    var g = canvas.getContext('2d');

    // Orientation courante : point sous le reticule. Depart NEUTRE (Afrique du
    // Nord / Mediterranee) : au chargement, Geiger au repos et boussole calme.
    // L'anomalie ne se declenche que si l'utilisateur vise la zone Tchernobyl.
    var lat0 = 25, lon0 = 12;
    var vlat = 0, vlon = 0;             // vitesses (inertie apres lacher)
    var W = 0, H = 0, cx = 0, cy = 0, R = 0;

    function fit() {
      var dpr = Math.min(global.devicePixelRatio || 1, 2.5);
      W = host.clientWidth || 240; H = host.clientHeight || 240;
      canvas.width = Math.round(W * dpr); canvas.height = Math.round(H * dpr);
      canvas.style.width = W + 'px'; canvas.style.height = H + 'px';
      g.setTransform(dpr, 0, 0, dpr, 0, 0);
      cx = W / 2; cy = H / 2; R = Math.min(W, H) / 2 - 4;
    }

    // ── Projection orthographique ──
    var sphi0, cphi0, lam0;
    function setCenter() { var p = lat0 * DEG; sphi0 = Math.sin(p); cphi0 = Math.cos(p); lam0 = lon0 * DEG; }
    function project(latDeg, lonDeg, out) {
      var phi = latDeg * DEG, lam = lonDeg * DEG, dl = lam - lam0;
      var cphi = Math.cos(phi), sphi = Math.sin(phi), cdl = Math.cos(dl);
      out.z = sphi0 * sphi + cphi0 * cphi * cdl;
      out.x = cx + R * (cphi * Math.sin(dl));
      out.y = cy - R * (cphi0 * sphi - sphi0 * cphi * cdl);
      return out;
    }

    var pA = { x: 0, y: 0, z: 0 }, pB = { x: 0, y: 0, z: 0 };

    function drawPolyline(pts, color, width) {
      g.strokeStyle = color; g.lineWidth = width; g.lineJoin = 'round'; g.lineCap = 'round';
      var started = false;
      for (var i = 0; i < pts.length; i++) {
        project(pts[i][1], pts[i][0], pA);
        if (pA.z > 0) {
          if (!started) { g.beginPath(); g.moveTo(pA.x, pA.y); started = true; }
          else g.lineTo(pA.x, pA.y);
        } else if (started) { g.stroke(); started = false; }
      }
      if (started) g.stroke();
    }

    function graticule() {
      g.strokeStyle = 'rgba(90,255,150,.10)'; g.lineWidth = 1;
      var lat, lon, first;
      for (lon = -150; lon <= 180; lon += 30) {           // meridiens
        first = true;
        for (lat = -80; lat <= 80; lat += 5) {
          project(lat, lon, pA);
          if (pA.z > 0) { if (first) { g.beginPath(); g.moveTo(pA.x, pA.y); first = false; } else g.lineTo(pA.x, pA.y); }
          else if (!first) { g.stroke(); first = true; }
        }
        if (!first) g.stroke();
      }
      for (lat = -60; lat <= 60; lat += 30) {              // paralleles
        first = true;
        for (lon = -180; lon <= 180; lon += 5) {
          project(lat, lon, pA);
          if (pA.z > 0) { if (first) { g.beginPath(); g.moveTo(pA.x, pA.y); first = false; } else g.lineTo(pA.x, pA.y); }
          else if (!first) { g.stroke(); first = true; }
        }
        if (!first) g.stroke();
      }
    }

    function drawGlobe() {
      g.clearRect(0, 0, W, H);
      // ocean sombre
      g.save();
      g.beginPath(); g.arc(cx, cy, R, 0, TAU); g.clip();
      var grd = g.createRadialGradient(cx - R * 0.3, cy - R * 0.35, R * 0.1, cx, cy, R);
      grd.addColorStop(0, '#0e2436'); grd.addColorStop(0.6, '#071624'); grd.addColorStop(1, '#030a12');
      g.fillStyle = grd; g.beginPath(); g.arc(cx, cy, R, 0, TAU); g.fill();
      graticule();
      // continents en vert phosphore
      var cl = World.coastlines;
      for (var i = 0; i < cl.length; i++) drawPolyline(cl[i], 'rgba(90,255,150,.85)', 1.4);
      // terminateur / relief : leger assombrissement d'un cote
      var tg = g.createRadialGradient(cx - R * 0.5, cy - R * 0.5, R * 0.2, cx, cy, R * 1.15);
      tg.addColorStop(0, 'rgba(0,0,0,0)'); tg.addColorStop(1, 'rgba(0,0,0,.55)');
      g.fillStyle = tg; g.beginPath(); g.arc(cx, cy, R, 0, TAU); g.fill();
      g.restore();
      // halo atmospherique
      g.beginPath(); g.arc(cx, cy, R, 0, TAU);
      g.strokeStyle = 'rgba(120,220,255,.25)'; g.lineWidth = 2; g.stroke();
      g.beginPath(); g.arc(cx, cy, R + 2, 0, TAU);
      g.strokeStyle = 'rgba(90,255,150,.12)'; g.lineWidth = 4; g.stroke();
    }

    // ── Pilotage des autres instruments ──
    var readEl = document.getElementById('pnlGlobeRead');
    var readB = readEl ? readEl.querySelector('b') : null;
    // Deuxieme ligne pour le libelle de zone (evite de tronquer sur 240 px).
    var readP = null;
    if (readEl) { readEl.appendChild(document.createElement('br')); readP = document.createElement('span'); readEl.appendChild(readP); }
    var buzzing = false;
    var THRESH = 1.0;                                       // µSv/h : seuil d'affolement
    var geigerAudio = makeGeigerAudio();                   // crepitement sonore

    function drive() {
      var dose = World.radiationAt(lat0, lon0);
      var temp = World.tempAt(lat0, lon0);
      geigerAudio.setDose(dose);                            // cadence des clics
      var geiger = document.getElementById('pnlGeiger');
      var thermo = document.getElementById('pnlThermo');
      var compass = document.getElementById('pnlCompass');
      if (geiger && geiger._sxp) geiger._sxp.set(dose);
      if (thermo && thermo._sxp) thermo._sxp.set(temp);

      var hot = dose > THRESH;
      if (hot !== buzzing) {
        buzzing = hot;
        if (geiger) geiger.classList.toggle('sxp-buzz', hot && !REDUCE);
      }
      if (compass && compass._sxp) {
        if (hot) compass._sxp.set('spin');                 // aiguille affolee
        else compass._sxp.set(((lon0 % 360) + 360) % 360); // cap = orientation
      }
      if (readB) {
        var ns = lat0 >= 0 ? 'N' : 'S', ew = lon0 >= 0 ? 'E' : 'O';
        readB.textContent = Math.abs(lat0).toFixed(1) + '°' + ns + '  ' +
          Math.abs(((lon0 + 540) % 360) - 180).toFixed(1) + '°' + ew;
        if (readP) readP.textContent = World.place(lat0, lon0);
      }
    }

    // ── Interaction (drag souris + tactile) ──
    var dragging = false, lastX = 0, lastY = 0, moved = false;
    function down(e) {
      dragging = true; moved = false;
      geigerAudio.unlock();                                 // 1er geste : debloque le son
      lastX = e.clientX; lastY = e.clientY; vlat = vlon = 0;
      if (canvas.setPointerCapture && e.pointerId != null) { try { canvas.setPointerCapture(e.pointerId); } catch (er) {} }
    }
    function move(e) {
      if (!dragging) return;
      var dx = e.clientX - lastX, dy = e.clientY - lastY;
      lastX = e.clientX; lastY = e.clientY; moved = true;
      var k = 0.4;                                          // sensibilite deg/px
      lon0 -= dx * k;                                       // glisser droite -> tourne vers l'ouest
      lat0 = clamp(lat0 + dy * k, -85, 85);                // glisser bas -> descend vers le sud
      lon0 = ((lon0 % 360) + 540) % 360 - 180;
      vlon = -dx * k; vlat = dy * k;
      setCenter();
    }
    function up(e) {
      dragging = false;
      if (canvas.releasePointerCapture && e && e.pointerId != null) { try { canvas.releasePointerCapture(e.pointerId); } catch (er) {} }
    }
    if (global.PointerEvent) {
      canvas.addEventListener('pointerdown', function (e) { down(e); e.preventDefault(); });
      canvas.addEventListener('pointermove', move);
      canvas.addEventListener('pointerup', up);
      canvas.addEventListener('pointercancel', up);
    } else {
      canvas.addEventListener('mousedown', function (e) { down(e); e.preventDefault(); });
      global.addEventListener('mousemove', move);
      global.addEventListener('mouseup', up);
      canvas.addEventListener('touchstart', function (e) { var t = e.touches[0]; down({ clientX: t.clientX, clientY: t.clientY }); e.preventDefault(); }, { passive: false });
      canvas.addEventListener('touchmove', function (e) { var t = e.touches[0]; move({ clientX: t.clientX, clientY: t.clientY }); e.preventDefault(); }, { passive: false });
      canvas.addEventListener('touchend', up);
    }

    // ── Boucle de rendu ──
    var raf = 0, driveAccum = 0, vr = visibleRaf(canvas);
    function loop() {
      if (!dragging && !REDUCE) {                           // inertie apres lacher
        lat0 = clamp(lat0 + vlat, -85, 85);
        lon0 = ((lon0 - vlon) % 360 + 540) % 360 - 180;
        vlat *= 0.94; vlon *= 0.94;
        if (Math.abs(vlat) < 0.002) vlat = 0;
        if (Math.abs(vlon) < 0.002) vlon = 0;
        setCenter();
      }
      drawGlobe();
      // pilotage des instruments a ~20 Hz (suffisant, moins de charge)
      if (++driveAccum >= 3) { driveAccum = 0; drive(); }
      raf = vr.request(loop);
    }

    fit(); setCenter(); drawGlobe(); drive();
    global.addEventListener('resize', function () { fit(); setCenter(); drawGlobe(); });
    if (REDUCE) {
      // Sans animation : rendu statique, mais le globe reste orientable au drag.
      canvas.addEventListener('pointermove', function () { drawGlobe(); drive(); });
      canvas.addEventListener('mousemove', function () { drawGlobe(); drive(); });
      canvas.addEventListener('touchmove', function () { drawGlobe(); drive(); });
    } else {
      raf = vr.request(loop);
    }
  }

  function init() { build(document.getElementById('pnlGlobe')); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})(window);
